var url = window.location.href,
    parts = url.split("/"),
    last_part = parts[parts.length - 1];

if (last_part == '') {
    last_part = parts[parts.length - 2];
}
var currentLang = $('input[name="locale_code"]').val();

// let lang = 0;
// if(currentLang == 'de'){
//    lang = 0;
// } 
// else if(currentLang == 'en'){
//    lang = 1;
// }
// else if(currentLang == 'fr'){
//    lang = 2;
// } 

var spielbutton = ['Zum Spielplan','To Fixtures & Results','Vers Calendrier & Resultats'];
var spectators = ['ZUSCHAUER','SPECTATORS','SPECTATEURS'];
var referee = ['SCHIEDSRICHTER','REFEREE','ARBITRE'];

var isWoman = false;
if (window.location.href.indexOf("frauen") > -1) {
    isWoman = true;
  $('body').addClass('template-frauen-match-center');
}
else
{
  $('section.tweeter-feed').removeClass('hidden');
}

var gender = 'MEN';
if (isWoman == true) {
    gender = 'WOMEN';
}
if ($.isNumeric(last_part)) {
  var match_url = API_URL+'match-center/soccer-matches/id/'+last_part+'?isDetailed=1';
  var is_old = true;
}else{
  var match_url = API_URL+'match-center/soccer-matches/latest?filter[type]='+gender+'&isDetailed=1';
  var is_old = false;
}
var slidetoshow = 6;
// console.log('is_old',is_old);

var settings = {
    "url": match_url,
    "method": "GET",
    "timeout": 0,
    "headers": {
        "Accept": "application/vnd.api+json",
        "Authorization": AUTH,
        "Content-Type": "application/vnd.api+json"
    },
};

$.ajax(settings).done(function(response) {
  destroyCarousel();
  setTimeout(function() {
      slickCarousel();
  }, 1000);
  $('#status').fadeOut();
  $('#preloader').fadeOut('slow');

  //console.log(response);
  var data = response.data;
  var details = response.data.deprecatedDetails;
  var soccerLeague = response.data.soccerLeague.translations[0].name;
  var matchID = data.id;

  if (data.soccerLeague.type == 'MEN') {
      var gender = 'MEN';
  } else {
      var gender = 'WOMEN';
      $('.section-frauen-partners').removeClass('hidden');
      $('.section-partners').addClass('hidden');
  }

  
  var regularTimeHome = data.regularTimeHome;
  var regularTimeGuest = data.regularTimeGuest;


  if (regularTimeHome == null && regularTimeGuest == null) {
      var score = 'VS';
  } else {
    var scoreClass = '';
    var iSNP = false;
    var isnV = false;
    if ((data.atForfeitHome != null && data.atForfeitGuest != null) && (data.atForfeitHome != 0 && data.atForfeitGuest != 0)) {
        regularTimeHome = data.atForfeitHome;
        regularTimeGuest = data.atForfeitGuest;
        scoreClass = 'hidden';
    } else if ((data.penaltyShootoutHome != null && data.penaltyShootoutGuest != null) && (data.penaltyShootoutHome != 0 && data.penaltyShootoutGuest != 0)) {
        regularTimeHome = data.penaltyShootoutHome;
        regularTimeGuest = data.penaltyShootoutGuest;
        iSNP = true;
        scoreClass = 'hidden';
    } else if ((data.extraTimeHome != null && data.extraTimeGuest != null) && (data.extraTimeHome != 0 && data.extraTimeGuest != 0)) {
        regularTimeHome = data.extraTimeHome;
        regularTimeGuest = data.extraTimeGuest;
        isnV = true;
        scoreClass = 'hidden';
    } else if (data.regularTimeHome != null && data.regularTimeGuest != null) {
        regularTimeHome = data.regularTimeHome;;
        regularTimeGuest = data.regularTimeGuest;
    }
    var score = regularTimeHome + ':' + regularTimeGuest;
    console.log('first',score);
  }

  /*if(data.status == 'FIRST HALF'){
    
    if((data.regularTimeHome == null && data.regularTimeGuest == null) && (data.halfTimeHome == null && data.halfTimeGuest == null)){
      score = '0:0';
    }
    else if(data.halfTimeHome == null && data.halfTimeGuest != null){
      score = '0:'+data.halfTimeGuest;
    }
    else if(data.halfTimeHome != null && data.halfTimeGuest == null){
      score = data.halfTimeHome + ':0';
    }
    else if(data.regularTimeHome != null && data.regularTimeGuest!=null){
      score = data.regularTimeHome+':'+data.regularTimeGuest;
    }
    else{
      score = data.halfTimeHome+':'+data.halfTimeGuest;
    }
    if(data.regularTimeHome == null && data.regularTimeGuest==null){
      var scoreClass = 'hidden';
    }
    console.log('FIRST HALF',score);
  }*/
  if(data.status == 'FIRST HALF'){
    
    if(data.halfTimeHome == null && data.halfTimeGuest == null){
      score = '0:0';
    }
    else if(typeof data.halfTimeHome === 'undefined' || typeof data.halfTimeGuest === 'undefined'){
      score = '0:0';
    }
    else if(data.halfTimeHome == null && data.halfTimeGuest != null){
      score = '0:'+data.halfTimeGuest;
    }
    else if(data.halfTimeHome != null && data.halfTimeGuest == null){
      score = data.halfTimeHome + ':0';
    }
    else if(data.halfTimeHome != null && data.halfTimeGuest!=null){
      score = data.halfTimeHome+':'+data.halfTimeGuest;
    }
    else if(data.regularTimeHome != null && data.regularTimeGuest!=null){
      score = data.regularTimeHome+':'+data.regularTimeGuest;
    }
    else{
      score = data.halfTimeHome+':'+data.halfTimeGuest;
    }
    if(data.regularTimeHome == null && data.regularTimeGuest==null){
      var scoreClass = 'hidden';
    }
  }
  if(data.status == 'SECOND HALF'){
    
    if((data.regularTimeHome == null && data.regularTimeGuest == null) && (data.halfTimeHome == null && data.halfTimeGuest == null)){
      score = '0:0';
    }
    else if(data.halfTimeHome == null && data.halfTimeGuest != null){
      score = '0:'+data.halfTimeGuest;
    }
    else if(data.halfTimeHome != null && data.halfTimeGuest == null){
      score = data.halfTimeHome + ':0';
    }
    else if(data.regularTimeHome != null && data.regularTimeGuest!=null){
      score = data.regularTimeHome+':'+data.regularTimeGuest;
    }
    else if(data.regularTimeHome == null && data.regularTimeGuest != null){
      score = data.halfTimeHome+':'+data.regularTimeGuest;
    }
    else if(data.regularTimeHome != null && data.regularTimeGuest==null){
      score = data.regularTimeHome+':'+data.halfTimeGuest;
    }
    else{
      score = data.halfTimeHome+':'+data.halfTimeGuest;
    }
    if(data.halfTimeHome != null && data.halfTimeGuest != null){
      var halfTimeHome = data.halfTimeHome;
      var halfTimeGuest = data.halfTimeGuest;
    }else if(data.halfTimeHome == null && data.halfTimeGuest != null){
      var halfTimeHome = '0';
      var halfTimeGuest = data.halfTimeGuest;
    }
    else if(data.halfTimeHome != null && data.halfTimeGuest == null){
      var halfTimeHome = data.halfTimeHome;
      var halfTimeGuest = '0';
    }else{
      var halfTimeHome = '0';
      var halfTimeGuest = '0';
    }
    var scoreClass = 'show';
    // if(data.regularTimeHome == null && data.regularTimeGuest==null){
    //   var scoreClass = 'hidden';
    // }
  }
  if(data.status == 'NOT STARTED' && (data.regularTimeHome == null && data.regularTimeGuest == null) && (data.halfTimeHome == null && data.halfTimeGuest == null)){
    var scoreClass = 'hidden';
    score = 'VS';
  }
  if(data.status == 'PAUSE'){
    var scoreClass = 'hidden';
  }
  if((regularTimeHome == null && regularTimeGuest == null) && data.halfTimeHome != null && data.halfTimeGuest != null ){
    score = data.halfTimeHome+':'+data.halfTimeGuest;
  }
  console.log('last',score);

  if(data.status == 'DEFERRED' || data.status == 'ABORTED' || data.status == 'INTERRUPTED'){      
      $('.tab-pane-content-matchcenter .current-match-wrapper .match-status').addClass('red');      
      score = 'VS'; 
      $('.tab-pane-content-matchcenter .current-match-wrapper .team-score-wrapper .team-time').hide();
      $('.tab-pane-content-statistik .fcz-statistic-progressbar .team-time').hide();
  }
  
  if (data.homeClub != null) {
    $('.tab-pane-content-matchcenter .current-match-wrapper .team-1 .team-img img').attr('src', data.homeClub.logo);
    $('.tab-pane-content-matchcenter .current-match-wrapper .team-1 .team-name').text(data.homeClub.name);
    $('.aufstellung-main.aufstellung .aufstellung-center .home-team-name').text(data.homeClub.name);

    $('.tab-pane-content-statistik .fcz-statistic-progressbar__head .statistic-team-1 img').attr('src', data.homeClub.logo);
    $('.tab-pane-content-statistik .fcz-statistic-progressbar__head .statistic-team-1 .team-name-one').text(data.homeClub.name);

    $('.tab-pane-content-aufstellung .ersatzbank-home .aufstellung-right .team-2 .team-img img').attr('src', data.homeClub.logo);
    $('.tab-pane-content-aufstellung .aufstellung .aufstellung-left .team-1 .team-img img').attr('src', data.homeClub.logo);
    $('.tab-pane-content-aufstellung .slick-aufstellung-mobile .aufstellung-home .team-1 .team-img img').attr('src', data.homeClub.logo);
  }

  if (data.guestClub != null) {
    $('.tab-pane-content-matchcenter .current-match-wrapper .team-2 .team-img img').attr('src', data.guestClub.logo);
    $('.tab-pane-content-matchcenter .current-match-wrapper .team-2 .team-name').text(data.guestClub.name);
    $('.aufstellung-main.aufstellung .aufstellung-center .guest-team-name').text(data.guestClub.name);

    $('.tab-pane-content-statistik .fcz-statistic-progressbar__head .statistic-team-2 img').attr('src', data.guestClub.logo);
    $('.tab-pane-content-statistik .fcz-statistic-progressbar__head .statistic-team-2 .team-name-two').text(data.guestClub.name);

    $('.tab-pane-content-aufstellung .aufstellung .aufstellung-right .team-2 .team-img img').attr('src', data.guestClub.logo);
    $('.tab-pane-content-aufstellung .ersatzbank-guest .aufstellung-right .team-2 .team-img img').attr('src', data.guestClub.logo);
    $('.tab-pane-content-aufstellung .slick-aufstellung-mobile .aufstellung-guest .team-2 .team-img img').attr('src', data.guestClub.logo);
  }
  $('.tab-pane-content-matchcenter .current-match-wrapper .team-score-wrapper .team-score').text(score);
  $('.tab-pane-content-statistik .fcz-statistic-progressbar .team-score').text(score);

  if (data.halfTimeHome != null && data.halfTimeGuest != null && scoreClass != 'hidden' ) {
    $('.tab-pane-content-matchcenter .current-match-wrapper .team-score-wrapper .team-time').text('(' + data.halfTimeHome + ':' + data.halfTimeGuest + ')');
    $('.tab-pane-content-statistik .fcz-statistic-progressbar .team-time').text('(' + data.halfTimeHome + ':' + data.halfTimeGuest + ')');
  }
  if (scoreClass == 'show' ) {
    $('.tab-pane-content-matchcenter .current-match-wrapper .team-score-wrapper .team-time').text('(' + halfTimeHome + ':' + halfTimeGuest + ')');
    $('.tab-pane-content-statistik .fcz-statistic-progressbar .team-time').text('(' + halfTimeHome + ':' + halfTimeGuest + ')');
  }
  if (iSNP == true) {
    $('.tab-pane-content-matchcenter .current-match-wrapper .team-score-wrapper .team-time').text('n.P.');
    $('.tab-pane-content-statistik .fcz-statistic-progressbar .team-time').text('n.P.');
    if ((data.extraTimeHome != null && data.extraTimeGuest != null) && (data.extraTimeHome != 0 && data.extraTimeGuest != 0)) {
        $('.tab-pane-content-matchcenter .current-match-wrapper .team-score-wrapper .extra-team-time').text('(' + data.extraTimeHome + ':' + data.extraTimeGuest + ') n.V.');
        $('.tab-pane-content-statistik .fcz-statistic-progressbar .extra-team-time').text('(' + data.extraTimeHome + ':' + data.extraTimeGuest + ') n.V.');
    }
  }
  if (isnV == true) {
    $('.tab-pane-content-matchcenter .current-match-wrapper .team-score-wrapper .team-time').text('n.V.');
    $('.tab-pane-content-statistik .fcz-statistic-progressbar .team-time').text('n.V.');
  }
  if (isnV == true || iSNP == true) {
    if (data.regularTimeHome != null && data.regularTimeGuest != null) {
      $('.tab-pane-content-matchcenter .current-match-wrapper .team-score-wrapper .regular-team-time').text('(' + data.regularTimeHome + ':' + data.regularTimeGuest + ') 90\'');
      $('.tab-pane-content-statistik .fcz-statistic-progressbar .regular-team-time').text('(' + data.regularTimeHome + ':' + data.regularTimeGuest + ') 90\'');
    }
    if (data.halfTimeHome != null && data.halfTimeGuest != null) {
      $('.tab-pane-content-matchcenter .current-match-wrapper .team-score-wrapper .half-team-time').text('(' + data.halfTimeHome + ':' + data.halfTimeGuest + ') 45\'');
      $('.tab-pane-content-statistik .fcz-statistic-progressbar .half-team-time').text('(' + data.halfTimeHome + ':' + data.halfTimeGuest + ') 45\'');
    }
  }
  if(data.status != ''){
    var matchStatus = '';
    var matchStatusLang = ['','',''];
    if(data.status == 'FIRST HALF'){
      matchStatus = '1. HALBZEIT';
      matchStatusLang = ['1. HALBZEIT','1. HALF','1. PÉRIODE'];
    }else if(data.status == 'SECOND HALF'){
      matchStatus = '2. HALBZEIT';
      matchStatusLang = ['2. HALBZEIT','2. HALF','2. PÉRIODE'];
    }else if(data.status == 'DELAYED'){
      matchStatus = 'VERSPÄTET';
      matchStatusLang = ['VERSPÄTET','DELAYED','RETARD'];
    }else if(data.status == 'FINISHED'){
      matchStatus = 'BEENDET';
      matchStatusLang = ['BEENDET','FULL TIME','TERMINÉ'];
    }else if(data.status == 'DEFERRED'){
      matchStatus = 'VERSCHOBEN';
      matchStatusLang = ['VERSCHOBEN','POSTPONED','AJOUTEE'];
    }else if(data.status == 'ABORTED'){
      matchStatus = 'ABGEBROCHEN';
      matchStatusLang = ['ABGEBROCHEN','CANCELLED','ANNULÉ'];
    }else if(data.status == 'INTERRUPTED'){
      matchStatus = 'UNTERBROCHEN';
      matchStatusLang = ['UNTERBROCHEN','INTERRUPTED','INTERROMPU'];
    }else if(data.status == 'PAUSE'){
      matchStatus = 'PAUSE';
      matchStatusLang = ['PAUSE','HALF TIME','PAUSE'];
    }else if(data.status == 'FIRST EXTENSION'){
      matchStatus = '1. VERLÄNGERUNG';
      matchStatusLang = ['1. VERLÄNGERUNG','1. EXTRA TIME','1. PROLONGATION'];
    }else if(data.status == 'PAUSE EXTENSION'){
      matchStatus = 'PAUSE (VERLÄNGERUNG)';
      matchStatusLang = ['PAUSE (VERLÄNGERUNG)','HALF TIME (EXTRA TIME)','PAUSE (PROLONGATION)'];
    }else if(data.status == 'SECOND EXTENSION'){
      matchStatus = '2. VERLÄNGERUNG';
      matchStatusLang = ['2. VERLÄNGERUNG','2. EXTRA TIME','2. PROLONGATION'];
    }
    console.log('data.status',data.status)
    $('.tab-pane-content-matchcenter .current-match-wrapper').prepend('<div class="match-status"><strong>'+matchStatusLang[lang]+'</strong></div>');
  }

  /* Hide score till second half */
    if(data.status == '' || data.status == 'NOT STARTED' || data.status == 'FIRST HALF'){
      $('.tab-pane-content-matchcenter .current-match-wrapper .team-score-wrapper .team-time').hide();
      $('.tab-pane-content-statistik .fcz-statistic-progressbar .team-time').hide();
  }
  
  if(data.status == '' || data.status=='NOT STARTED'){
    
    var match_date_ori = data.date;
    var match_date = match_date_ori.split(" ");
    var match_newdate = match_date[0].split(".").reverse().join("-");
    var match_newdate_time = match_newdate + ' ' + match_date[1];
    var match_date_final = new Date(match_newdate_time);        
    var today = new Date();

    if (match_date_ori != null) {
        // Add Date for Future Match
        $('.tab-pane-content-matchcenter .match_date').text(formatDateStringforfuturematch(match_date_final));
    }
  }

  if (data.arenaName != null && data.arenaName != "") {
    if(data.arenaCity != null && data.arenaCity != ''){
      arenaCity = ', '+data.arenaCity;
    }else{
      arenaCity = '';
    }
      $('.tab-pane-content-matchcenter .live__matchinfo .stadium-wrapper').html('<span><strong>' + data.arenaName + arenaCity+'</strong></span>');
  }
  if (data.numberOfSpectators == null) {
      $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').hide();
  } else if (data.numberOfSpectators == 0) {
      $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').hide();
  } else {
      $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').show();
      $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').html('<span> ' + data.numberOfSpectators + ' '+ spectators[lang] +'</span>');
  }
   
  if (data.refereeName != null && data.refereeName != "") {
      $('.tab-pane-content-matchcenter .live__matchinfo .rafree-wrapper').show();
      $('.tab-pane-content-matchcenter .live__matchinfo .rafree-wrapper').html('<span><strong> '+ referee[lang] +': </strong> ' + data.refereeName + '</span>');
  } else {
      $('.tab-pane-content-matchcenter .live__matchinfo .rafree-wrapper').hide();
  }


  var homeClubLineup = data.deprecatedHomeClubLineup;
  var guestClubLineup = data.deprecatedGuestClubLineup;
  if((data.optaId == null || data.optaId == '') && (data.sflId == '' || data.sflId == null )){
    console.log('Normal Match');
    
    if (homeClubLineup != null && homeClubLineup != "") {
      if (homeClubLineup.indexOf('Ersatz') != -1 || homeClubLineup.indexOf('Auf der Bank') != -1){
        if (homeClubLineup.indexOf('Ersatz') != -1){
          var homeCluball = homeClubLineup.split('Ersatz');
        }
        if (homeClubLineup.indexOf('Auf der Bank') != -1){
          var homeCluball = homeClubLineup.split('Auf der Bank');
        }
        var str = "\r\n";
        if (homeClubLineup.indexOf(str) != -1) {
            var homeClubLineup = homeCluball[0].split('\r\n');
            var homeClubbatch = homeCluball[1].split('\r\n');
        } else {
            var homeClubLineup = homeCluball[0].split('\n');
            var homeClubbatch = homeCluball[1].split('\n');
        }
          
        var playerTeamA = '';
        var playerTeamA_batch = '';
  
        for (var hc = 0; hc < homeClubLineup.length; hc++) {
  
            var teamas = '';
            var player = homeClubLineup[hc].split(',');
  
            if (player[0] != '' && typeof player[0] !== 'undefined') {
  
                if (player[2] != '' && typeof player[2] !== 'undefined') {
                    teamas = '<span class="inout">' + player[2].replace('|inout', '') + '</span>';
                }
                if (typeof player[1] === 'undefined') {} else {
                    playerTeamA += '<li>' + player[0] + ' ' + player[1] + teamas + '</li>';
                }
            }
        }
  
        $('.aufstellung .aufstellung-list-1').html(playerTeamA);
        $('.ersatzbank-home .aufstellung-list-1').html(playerTeamA);
        $('.aufstellung .aufstellung-head').hide();
        $('.ersatzbank-home .aufstellung-head').hide();
  
        for (var hc = 0; hc < homeClubbatch.length; hc++) {
            var teamas = '';
            var player = homeClubbatch[hc].split(',');
            if (player[0] != '' && typeof player[0] !== 'undefined') {
                if (player[2] != '' && typeof player[2] !== 'undefined') {
                    teamas = '<span class="inout">' + player[2].replace('|inout', '') + '</span>';
                }
                if (typeof player[1] === 'undefined') {} else {
                    playerTeamA_batch += '<li>' + player[0] + ' ' + player[1] + teamas + '</li>';
                }
            }
        }
        $('.ersatzbank-home .ersatzbank-list-1').html(playerTeamA_batch);
  
        var hometeam_lineup_players_pos_html = '';
        for (var a = 0, b = 0; a < homeClubLineup.length; a++, b++) {
  
            var player = homeClubLineup[a].split(',');
  
            if (player[0] != '' && typeof player[0] !== 'undefined') {
                if (player[2] != '' && typeof player[2] !== 'undefined') {}
                if (typeof player[1] === 'undefined') {} else {
                    hometeam_lineup_players_pos_html += '<span class="plyr p' + b + '">' + player[0] + '</span>';
                }
            }
  
        }

        $('.aufstellung-main.aufstellung .lineup-field-wrapper .team-one-player-list').html(hometeam_lineup_players_pos_html);
        $('.aufstellung-main.ersatzbank-home .lineup-field-wrapper .team-one-player-list').html(hometeam_lineup_players_pos_html);
        $('.aufstellung-main.ersatzbank-home .lineup-field-wrapper .team-one-player-list').before('<h2 class="team-name">FC Zürich</h2>');
      }
      else {
        $('.tab-pane-content-aufstellung .aufstellung-main.aufstellung').css('align-items', 'flex-start');
        $('.tab-pane-content-aufstellung .aufstellung-main .aufstellung-list-1').html('<li>Sobald die Aufstellung bekannt ist, wird diese angezeigt.</li>');
      }
    }else{
      $('.aufstellung[data-id="#tab-4"]').hide();    
    }
  
  
    if (guestClubLineup != null && guestClubLineup != "") {
      if (guestClubLineup.indexOf('Ersatz') != -1 || guestClubLineup.indexOf('Auf der Bank') != -1){
        if (guestClubLineup.indexOf('Ersatz') != -1){
          var guestCluball = guestClubLineup.split('Ersatz');
        }
        if (guestClubLineup.indexOf('Auf der Bank') != -1){
          var guestCluball = guestClubLineup.split('Auf der Bank');
        }
                  
        var str = "\r\n";
        if (guestClubLineup.indexOf(str) != -1) {
            var guestClubLineup = guestCluball[0].split('\r\n');
            var guestClubbatch = guestCluball[1].split('\r\n');
        } else {
            var guestClubLineup = guestCluball[0].split('\n');
            var guestClubbatch = guestCluball[1].split('\n');
        }
    
        var playerTeamB = '';
        var playerTeamB_batch = '';
    
        for (var hc = 0; hc < guestClubLineup.length; hc++) {
          var teambs = '';
          var player = guestClubLineup[hc].split(',');
          if (player[0] != '' && typeof player[0] !== 'undefined') {
            if (player[2] != '' && typeof player[2] !== 'undefined') {
              teambs = '<span class="inout">' + player[2].replace('|inout', '') + '</span>';
            }
            if (typeof player[1] === 'undefined') {} else {
              playerTeamB += '<li>' + player[0] + ' ' + player[1] + teambs + '</li>';
            }
          }
        }
    
        $('.aufstellung .aufstellung-list-2').html(playerTeamB);
        $('.ersatzbank-guest .aufstellung-list-2').html(playerTeamB);
        $('.aufstellung .aufstellung-head').hide();
        $('.ersatzbank-guest .aufstellung-head').hide();
    
        for (var hc = 0; hc < guestClubbatch.length; hc++) {
            var teambs = '';
            var player = guestClubbatch[hc].split(',');
            if (player[0] != '' && typeof player[0] !== 'undefined') {
                if (player[2] != '' && typeof player[2] !== 'undefined') {
                    teambs = '<span class="inout">' + player[2].replace('|inout', '') + '</span>';
                }
                if (typeof player[1] === 'undefined') {} else {
                    playerTeamB_batch += '<li>' + player[0] + ' ' + player[1] + teambs + '</li>';
                }
            }
        }
    
        $('.ersatzbank-guest .ersatzbank-list-2').html(playerTeamB_batch);
    
        var guestteam_lineup_players_pos_html = '';
        for (var a = 0, b = 0; a < guestClubLineup.length; a++, b++) {
    
            var player = guestClubLineup[a].split(',');
    
            if (player[0] != '' && typeof player[0] !== 'undefined') {
                if (player[2] != '' && typeof player[2] !== 'undefined') {}
                if (typeof player[1] === 'undefined') {} else {
                    guestteam_lineup_players_pos_html += '<span class="plyr p' + b + '">' + player[0] + '</span>';
                }
            }
    
        }
        $('.aufstellung-main.aufstellung .lineup-field-wrapper .team-two-player-list').html(guestteam_lineup_players_pos_html);
        $('.aufstellung-main.ersatzbank-guest .lineup-field-wrapper .team-two-player-list').html(guestteam_lineup_players_pos_html);
      }
      else {
        $('.tab-pane-content-aufstellung .aufstellung-main.aufstellung').css('align-items', 'flex-start');
        $('.tab-pane-content-aufstellung .aufstellung-main .aufstellung-list-2').html('<li>Sobald die Aufstellung bekannt ist, wird diese angezeigt.</li>');
        $('.tab-pane-content-aufstellung .aufstellung-center').hide();
      }  
    }

    var soccerHighlights = data.soccerHighlights;
    if (soccerHighlights.length > 0) {
      var teamA = '';
      var teamB = '';
      /*var homeTeamgoal = '',
          guestTeamgoal = '',
          homeTeamRed = '',
          guestTeamRed = '',
          homeTeamYellow = '',
          guestTeamYellow = '',
          homeTeamRedYellow = '',
          guestTeamRedYellow = '';*/
      for (var a = 0; a < soccerHighlights.length; a++) {
        
          if (soccerHighlights[a].club == 'Home' && soccerHighlights[a].highlightType == "Mark goal") {
             // homeTeamgoal += soccerHighlights[a].player + ', ';
              teamA += '<div class="highlight" style="order:' + soccerHighlights[a].minute + '"><div class="highlight__type"><span class="live__icon live__icon--goal"></span></div><div class="highlight__player"><strong>' + soccerHighlights[a].player + '</strong> (' + soccerHighlights[a].minute + '.)</div></div>';
          } else if (soccerHighlights[a].club == 'Guest' && soccerHighlights[a].highlightType == "Mark goal") {
            // guestTeamgoal += soccerHighlights[a].player + ', ';
            teamB += '<div class="highlight" style="order:' + soccerHighlights[a].minute + '"><div class="highlight__type"><span class="live__icon live__icon--goal"></span></div><div class="highlight__player"><strong>' + soccerHighlights[a].player + '</strong> (' + soccerHighlights[a].minute + '.)</div></div>';
          }
      }
      for (var b = 0; b < soccerHighlights.length; b++) {
          if (soccerHighlights[b].club == 'Home' && soccerHighlights[b].highlightType == "Mark yellow card") {
            // homeTeamYellow += soccerHighlights[b].player + ', ';
              teamA += '<div class="highlight" style="order:' + soccerHighlights[b].minute + '"><div class="highlight__type"><span class="live__icon live__icon--yellowcard"></span></div><div class="highlight__player"><strong>' + soccerHighlights[b].player + '</strong> (' + soccerHighlights[b].minute + '.)</div></div>';
          } else if (soccerHighlights[b].club == 'Guest' && soccerHighlights[b].highlightType == "Mark yellow card") {
            // guestTeamYellow += soccerHighlights[b].player + ', '
              teamB += '<div class="highlight" style="order:' + soccerHighlights[b].minute + '"><div class="highlight__type"><span class="live__icon live__icon--yellowcard"></span></div><div class="highlight__player"><strong>' + soccerHighlights[b].player + '</strong> (' + soccerHighlights[b].minute + '.)</div></div>';
          }
      }
     for (var b = 0; b < soccerHighlights.length; b++) {
          if (soccerHighlights[b].club == 'Home' && soccerHighlights[b].highlightType == "Mark red card") {
            // homeTeamRed += soccerHighlights[b].player + ', ';
              teamA += '<div class="highlight" style="order:' + soccerHighlights[b].minute + '"><div class="highlight__type"><span class="live__icon live__icon--redcard"></span></div><div class="highlight__player"><strong>' + soccerHighlights[b].player + '</strong> (' + soccerHighlights[b].minute + '.)</div></div>';
          } else if (soccerHighlights[b].club == 'Guest' && soccerHighlights[b].highlightType == "Mark red card") {
            // guestTeamRed += soccerHighlights[b].player + ', '
              teamB += '<div class="highlight" style="order:' + soccerHighlights[b].minute + '"><div class="highlight__type"><span class="live__icon live__icon--redcard"></span></div><div class="highlight__player"><strong>' + soccerHighlights[b].player + '</strong> (' + soccerHighlights[b].minute + '.)</div></div>';
          }
      }
      for (var b = 0; b < soccerHighlights.length; b++) {
          if (soccerHighlights[b].club == 'Home' && soccerHighlights[b].highlightType == "Mark yellow red card") {
            // homeTeamRedYellow += soccerHighlights[b].player + ', ';
              teamA += '<div class="highlight" style="order:' + soccerHighlights[b].minute + '"><div class="highlight__type"><span class="live__icon live__icon--yellowredcard"></span></div><div class="highlight__player"><strong>' + soccerHighlights[b].player + '</strong> (' + soccerHighlights[b].minute + '.)</div></div>';
          } else if (soccerHighlights[b].club == 'Guest' && soccerHighlights[b].highlightType == "Mark yellow red card") {
            // guestTeamRedYellow += soccerHighlights[b].player + ', ';
              teamB += '<div class="highlight" style="order:' + soccerHighlights[b].minute + '"><div class="highlight__type"><span class="live__icon live__icon--yellowredcard"></span></div><div class="highlight__player"><strong>' + soccerHighlights[b].player + '</strong> (' + soccerHighlights[b].minute + '.)</div></div>';
          }
      }
  
      $('.live__highlights .team-1').html(teamA);
      $('.live__highlights .team-2').html(teamB);
    }
  }
   
  // Match news
  if (data.news != null) {
      var news = '';
      news += '<div class="news-content-wrapper">';
      /*news += '<div class="tag-wrapper">';
      news += '<div class="tag-inner">';
      news += '<span>' + formatDate(data.news.publishDate) + '</span>';
      if (data.news.newsCategory != null) {
        var cat = data.news.newsCategory;
        news += '<a href="/pages/news?category=' + cat.id + '" class="button button-small">' + cat.translations[0].webName + '</a>';
      }
  
      news += '</div>';
      news += '</div>';*/
      news += '<div class="title-wrapper">';
      console.log(data.news.name);
      news += '<h2>' + data.news.name + '</h2>';
      news += '</div>';
      news += '<div class="tag-wrapper">';
      news += '<div class="tag-inner">';
      news += '<div class="news-category">';
      if (data.news.category != null) {
          var cat = data.news.category;
          var catName = cat.translations[0].webName;
          var catLink = '/pages/news?category=' + cat.id;
          if (catName == 'Profis') {
              catName = 'ERSTE MANNSCHAFT';
              catLink = '/pages/profis-erste-mannschaft';
          } else if (catName == 'Frauen') {
              catLink = '/pages/frauen-team-kader';
          }
          news += '<a href="' + catLink + '" class="news-cat">' + catName + ', </a>';
      }
      news += '</div>';
      if (data.news.publishDate != null) {
          news += '<span class="news-date">' + formatDate(data.news.publishDate) + ', </span>';
      }
      if (data.news.author != null) {
          news += '<span class="news-author"> ' + data.news.author + '</span>';
      }
      news += '</div>';
      news += '</div>';

      news += '<div class="description-wrapper">';
      var showcontentBuilder = 'false';
      if(data.news.contentBuilder != null ){
        var rows = data.news.contentBuilder.rows;
        if(rows.length > 0){
          showcontentBuilder = 'true';
          for(var row = 0; row<rows.length; row++ ){
          var columns = rows[row].columns;
          var isFullWidth = '';
          if(rows[row].order != null){
            var rowOrder = rows[row].order;
          }else{
            var rowOrder = '0';
          }
          if(rows[row].isFullWidth == 1){
            isFullWidth = 'fullwidth';
          }
          if(columns.length > 0){
            var totalColumns = columns.length;
          }else{
            var totalColumns = 0;
          }
          news += '<div class="content-row row__'+(row+1)+' '+isFullWidth+' total-columns-'+totalColumns+'" style="order:'+rowOrder+'">';
            if(columns.length > 0){
              for(var column = 0; column < columns.length; column++){
                var contentContainer  = columns[column].contentContainer;
                news += '<div class="content-column column__'+(column+1)+'">';
                  if(contentContainer != null){
                    var contents = contentContainer.contents;
                    if(contents.length > 0){
                      for(var content = 0; content < contents.length; content++ ){
                        var isSplit = contents[content].isSplit;;
                        var contentData = contents[content].contentData;
                        var contentType = contents[content].type;
                        if(contents[content].containerOrder != null){
                          var containerOrder = contents[content].containerOrder;
                        }else{
                          var containerOrder = '0';
                        }
                        
                        
                        if(contentData != null){
                          news += '<div class="content content__'+(content+1)+'" style="order:'+containerOrder+'">';
                          
                          if(contentType == 'HEADING'){
                            if(contentData.textColor != ''){
                              var textColor = 'color:'+contentData.textColor;
                            }else{ var textColor = '';}
                            news += '<div class="content-type-title">';
                              news += '<'+contentData.titleSize+' style="'+textColor+'">';
                                news += contentData.translations[0].title;
                              news += '</'+contentData.titleSize+'>';
                              if(contentData.translations[0].description != ''){
                                news += '<p>'+contentData.translations[0].description+'</p>';
                              }
                            news += '</div>';
                          } // end if contentType HEADING
                          if(contentType == 'TITLE'){
                            if(contentData.textColor != ''){
                              var textColor = 'color:'+contentData.titleColor;
                            }else{ var textColor = '';}
                            news += '<div class="content-type-title">';
                              news += '<'+contentData.size+' style="'+textColor+'">';
                                news += contentData.translations[0].title;
                              news += '</'+contentData.size+'>';
                              
                            news += '</div>';
                          } // end if contentType title

                          if(contentType == 'TEXT'){
                            var description = contentData.translations[0].text;
                            html += '<div class="content-type-text">';
                            if(contentData.picture == null ){
                              if(contentData.translations[0].title != null){
                                if(contentData.textColor != '' && contentData.textColor != null){
                                  var textColor = 'color:'+contentData.textColor;
                                }else{ var textColor = '';}
                                if(contentData.fontSize != '' && contentData.fontSize != null ){
                                  var textSize = 'font-size:'+contentData.fontSize+'px;';
                                }else{ var textSize = '' }
                                
                                html += '<'+contentData.titleSize+' style="'+textSize+textColor+'">'+contentData.translations[0].title+'</'+contentData.titleSize+'>';
                              }
                            }
                              if(description != null ){
                                html += description;
                              }
                              
                              if(contentData.picture != null ){
                                html += '<div class="image-container image-width--'+contentData.pictureSize+'" style="text-align:'+contentData.picturePosition+'">';
                                html += '<div class="image-container-inner">';
                                html += '<img src="'+contentData.picture+'" alt="" loading="lazy">';
                                if(contentData.translations[0].pictureLabel != null){
                                  html += '<span class="caption">'+contentData.translations[0].pictureLabel+'</span>';
                                }
                                html += '</div>';
                                html += '</div>';
                              }
                            html += '</div>';
                          } // end if contentType text

                          if(contentType == 'BULLET'){
                            news += '<div class="content-type-bullet">';
                              news += '<'+contentData.titleSize+'>'+contentData.translations[0].title+'</'+contentData.titleSize+'>';
                              news += '<p>'+contentData.translations[0].text+'</p>';

                              if(contentData.bulletBullets.length > 0){
                                news += '<ul>';
                                for(var b = 0; b<contentData.bulletBullets.length; b++){
                                  news +='<li>'+contentData.bulletBullets[b].translations[0].text+'</li>';
                                }
                                news += '</ul>';
                              }
                            news += '</div>';
                          } // end if contentType Bullet

                          if(contentType == 'TABLE'){
                            news += '<div class="content-type-table">';
                              news += '<'+contentData.titleSize+'>'+contentData.translations[0].title+'</'+contentData.titleSize+'>';
                              news += '<p>'+contentData.translations[0].additionalText+'</p>';

                              if(contentData.bulletBullets.length > 0){
                                news += '<table class="table table-styled">';
                                for(var b = 0; b<contentData.bulletBullets.length; b++){
                                  news += '<tr>';
                                  news +='<td>'+contentData.bulletBullets[b].translations[0].label+'</td>';
                                  news +='<td>'+contentData.bulletBullets[b].translations[0].content+'</td>';
                                  news += '</tr>';
                                }
                                news += '</table>';
                              }
                              
                            news += '</div>';
                          } // end if contentType TABLE

                          if(contentType == 'HTML'){
                            news += '<div class="content-type-html">';
                              news += '<p>'+contentData.translations[0].text+'</p>';
                            news += '</div>';
                          } // end if contentType html

                          if(contentType == 'LINK'){
                            news += '<div class="content-type-link">';
                              news += '<a href='+contentData.link+'>';
                              if(contentData.title != ''){
                                  news += contentData.title;
                              }else{
                                  news += contentData.link;
                              }
                              
                              news += '</a>';
                            news += '</div>';
                          } // end if contentType link

                          if(contentType == 'DOCUMENT'){
                            news += '<div class="content-type-document">';
                              if(contentData.translations[0].document != '' && contentData.translations[0].document != null){
                                  news += '<style>';
                                  news += '.document-button{ background-color:'+contentData.buttonBackgroundColor+';border: 1px solid '+contentData.buttonBorderColor+';padding: 10px;}';
                                  news += '.document-button:hover{ background-color:'+contentData.buttonHoverColor+';}';
                                  news += '.document-button a{ color:'+contentData.buttonTextColor+' !important;text-decoration: none;}';
                                  news += '</style>';
                                  if(contentData.isDocumentDisplayedAsButton == 1){
                                      var btnClass = 'document-button';
                                  }else {
                                      var btnClass = '';
                                  }
                                  news += '<button class="'+btnClass+'"><a target="_blank" href="'+contentData.translations[0].document+'">'+contentData.translations[0].title+'</a></button>';
                              }
                            news += '</div>';
                          } // end if contentType DOCUMENT

                          if(contentType == 'VIDEO'){
                            news += '<div class="content-type-video">';
                              if(contentData.videoUrl){
                              news += '<iframe title="'+contentData.translations[0].title+'" src="https://www.youtube.be/embed/'+youtube_parser(contentData.videoUrl)+'?feature=oembed&amp;enablejsapi=1&amprel=0;" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
                              //news += youtube_parser(contentData.videoUrl);
                              } else if(contentData.localVideoUrl) {
                              var videoClass = '';
                              if(contentData.isVideoMinimized == 1){
                                videoClass = 'VideoMinimized';
                              }
                              news += '<video class="'+videoClass+'" width="80%" controls><source src="'+contentData.localVideoUrl+'"></video>';
                              }
                            news += '</div>';
                          } // end if contentType video

                          if(contentType == 'DIVIDER'){
                            news += '<div class="content-type-divider">';
                              news += '<hr>';
                            news += '</div>';
                          } // end if contentType DIVIDER

                          if(contentType == 'CONTENT_CARD'){
                            news += '<div class="content-type-content-card">';
                              news += '<'+contentData.titleSize+'>';
                                news += contentData.translations[0].title;
                              news += '</'+contentData.titleSize+'>';
                              if(contentData.translations[0].text != ''){
                                news += '<p>'+contentData.translations[0].text+'</p>';
                              }
                              if(contentData.picture != '' && contentData.picture ){
                                news += '<img src="'+contentData.picture+'" loading="lazy">'
                              }
                            news += '</div>';
                          } // end if contentType CONTENT_CARD

                          if(contentType == 'CAROUSEL'){
                            news += '<div class="content-type-carousel">';
                            news += '<div id="news-media-wrapper" class="news-media-wrapper">';
                            if(contentData.contentCarouselImages.length > 0){
                              var album_image = contentData.contentCarouselImages;
                              if(album_image.length > 9){
                                slidetoshow = 9;
                              }
                              news += '<div class="news-slider slider-for">';
                              for(var ai = 0; ai < album_image.length; ai++){
                                news += '<div class="news-images">';
                                  news += '<img src="'+album_image[ai].picture+'" width="1300" alt="">';
                                  if(album_image[ai].translations[0].title != null ){
                                    news += '<span class="caption">'+album_image[ai].translations[0].title+'</span>';
                                  }
                                news += '</div>';
                              }
                              news += '</div>'; // end slider-for
                              news += '<div class="news-thumbnail slider-nav">';
            
                                for(var ai = 0; ai < album_image.length; ai++){
                                  var imgSrc = '';
                                  
                                  if(album_image[ai].picture != null){
                                    imgSrc = album_image[ai].picture;
                                  }else{
                                    imgSrc = album_image[ai].picture;
                                  }
                                  news += '<div class="news-thumbnail-images">';
                                      news += '<img src="'+imgSrc+'" alt="" width="150">';
                                  news += '</div>';
                                }
                                news += '</div>';

                              news += '</div>';
                            news += '</div>';
                            } // end if contentType album
                          }

                          if(contentType == 'ALBUM'){
                              news += '<div id="news-media-wrapper-1" class="news-media-wrapper">';
                              
                                var album_image = contentData.album.images;
                                
                                news += '<div class="news-slider slider-for">';
                                
                                if(album_image.length > 9){
                                  slidetoshow = 9;
                                }
                                
                                for(var ai = 0; ai < album_image.length; ai++){
                                  var imgSrc = '';
                                  
                                  if(album_image[ai].optimizedImage != null){
                                    imgSrc = album_image[ai].optimizedImage;
                                  }else{
                                    imgSrc = album_image[ai].url;
                                  }
                                  
                                  news += '<div class="news-images" data-order="'+album_image[ai].order+'">';
                                      news += '<img src="'+imgSrc+'" width="1300" alt="">';
                                      if(album_image[ai].translations[0].alternative_text != null ){
                                        news += '<span class="caption">'+album_image[ai].translations[0].alternative_text+'</span>';
                                      }
                                  news += '</div>';
                                }
                                news += '</div>';
                                
                                news += '<div class="news-thumbnail slider-nav">';
                                
                                for(var ai = 0; ai < album_image.length; ai++){
                                  var imgSrc = '';
                                  
                                  if(album_image[ai].optimizedImage != null){
                                    imgSrc = album_image[ai].optimizedImage;
                                  }else{
                                    imgSrc = album_image[ai].url;
                                  }
                                  news += '<div class="news-thumbnail-images" data-thumbnail-order="'+album_image[ai].order+'">';
                                      news += '<img src="'+imgSrc+'" alt="" width="150">';
                                  news += '</div>';
                                }
                                news += '</div>';
                              
                              news += '</div>';
                              
                          } // endif album
                          
                          news += '</div>'; // end content
                        } // end if contentData
                      } // end for content
                    } // end if content.length
                  } // end if contentContainer
                news += '</div>'; // end content-column
              } // end for column
            } // end if column.length
          news += '</div>'; // end content-row  
        } // end for rows
        } // end if row length
      }
      if(showcontentBuilder == 'false'){
        news += data.news.description;
        if (data.news.album != null) {
            news += '<div id="news-media-wrapper-1" class="news-media-wrapper">';
            
                var album_image = data.news.album.images;

                news += '<div class="news-slider slider-for">';

                if (album_image.length > 10) {
                    slidetoshow = 10;
                }

                for (var ai = 0; ai < album_image.length; ai++) {
                    var imgSrc = '';
                    if (album_image[ai].optimizedImage != null) {
                     imgSrc = album_image[ai].optimizedImage
                    }
                    else {
                      imgSrc = album_image[ai].url;
                    }
                                        
                    news += '<div class="news-images">';
                    news += '<img src="' + imgSrc + '" alt="" width="1300">';
                    if(album_image[ai].translations[0].caption != null){
                      news += '<span class="caption">' + album_image[ai].translations[0].caption + '</span>';
                    }
                    news += '</div>';
                }
                news += '</div>';

                news += '<div class="news-thumbnail slider-nav">';

                for (var ai = 0; ai < album_image.length; ai++) {
                    var imgSrc = '';
                    if (album_image[ai].optimizedImage != null) {
                     imgSrc = album_image[ai].optimizedImage
                    }
                    else {
                      imgSrc = album_image[ai].url;
                    }
                    news += '<div class="news-thumbnail-images">';
                    news += '<img src="' + imgSrc + '" alt="" width="100">';
                    news += '</div>';
                }
                news += '</div>';
            
            news += '</div>';

        } else {
            if (data.news.image != null) {
                news += '<div class="news-image-wrapper"><img src="' + data.news.image + '" alt="" loading="lazy"></div>';
            }
        }
      }
      news += '</div>';
      news += '</div>';

      $('.news-section-wrapper').html(news);

    $(".news-section-wrapper .news-slider").html($('.news-section-wrapper .news-slider .news-images').sort(function(x, y) {
     var value_x = $(x).data('order');
     var arr_x = [];
     arr_x = value_x
          
     var value_y = $(y).data('order');
     var arr_y = [];
     arr_y = value_y

     var arel = parseInt( arr_x);
     var brel = parseInt(arr_y);             

    return arel < brel ? -1 : 1;
   }));

  $(".news-section-wrapper .news-thumbnail").html($('.news-section-wrapper .news-thumbnail .news-thumbnail-images').sort(function(x, y) {
     var value_x = $(x).data('thumbnail-order');
     var arr_x = [];
     arr_x = value_x
          
     var value_y = $(y).data('thumbnail-order');
     var arr_y = [];
     arr_y = value_y

     var arel = parseInt( arr_x);
     var brel = parseInt(arr_y);             

    return arel < brel ? -1 : 1;
   }));
    
  } else {
    $('.news-section.matchcenter').remove();
  }

    
  //var match_date_ori = "19.01.2023 14:00";
  var match_date_ori = data.date;
  var match_date = match_date_ori.split(" ");
  var match_newdate = match_date[0].split(".").reverse().join("-");
  // var match_newdate = '2023-07-20';
  // console.log(match_newdate);
  var match_newdate_time = match_newdate + ' ' + match_date[1];
  var match_date_final = new Date(match_newdate_time);   
  var today = parseInt(new Date().getTime());      
  var FixedpastMatches = parseInt(new Date('2023-01-19 12:00:00').getTime());

  /*var match_date_final_swiss = new Date(match_newdate_time).toLocaleString('en-US', { timeZone: 'Europe/Zurich' });
  var today_swiss = new Date().toLocaleString('en-US', { timeZone: 'Europe/Zurich' });
  var match_next_day = addDays(new Date(match_date_final),2);*/
  //console.log(today_swiss,match_date_final_swiss);

  /* Removed for women & Non-SFL matches & Not Started */
   /*if(gender == 'women' || data.sflId == null || details == null || data.status != 'FINISHED' || match_date_final < FixedpastMatches){
      $('.row.embded-section').remove();
   }
   else {
       if (data.adVideo != null && data.adVideo != '') {
         var adVideohtml = '';
         //var adVideoURL = '6315504612112';
         var adVideoURL = data.adVideo;
         adVideohtml += `<div style="max-width: 720px;width: 100%;">
         <style>video-js.video-js.vjs-fluid:not(.vjs-audio-only-mode) {padding-top: 56.25%;}</style>
         <video-js data-account="2048251700001" data-player="RYrlKC6Ie" data-embed="default" controls="" data-video-id="${adVideoURL}" data-playlist-id="" data-application-id="" class="vjs-fluid">
         </video-js>
         </div>
         <script src="https://players.brightcove.net/2048251700001/RYrlKC6Ie_default/index.min.js"></script>`;
         $('.embded-section .embded-video-wrapper .embded-video-inner').html(adVideohtml);
         $('.row.embded-section .embded-video-wrapper .embded_acm_videobox').remove();
       }
       else {
          $('.row.embded-section .embded-video-wrapper .embded-video-inner').remove();
       }
   }*/

  if (match_date_final >= today && match_date_ori != null) {
      // Add Date for Future Match
      $('.tab-pane-content-matchcenter .match_date').text(formatDateStringforfuturematch(match_date_final));
  }

  
  //if((data.sflId == null || data.sflId == '') && (data.optaId != null || data.optaId != ''))
    if(gender == 'MEN'){
      var soccerLeagueId = response.data.soccerLeague.id;
    
      var settings_livetable = {
          // "url": API_URL+'match-center/soccer-matches/live-table/'+soccerLeagueId,
          "url": API_URL+'match-center/soccer-matches/'+matchID+'/table',
          "method": "GET",
          "timeout": 0,
          "headers": {
              "Authorization": AUTH,
              "Content-Type": "application/json"
          }
      };
     
      $.ajax(settings_livetable).done(function(response) {
        
          // console.log(response);
        var data = response.data;
        if(data != null){
          var table_html = '';
          var form = '';
          var form_text = '';
          var form_class = '';
          $('.match-center-tabs li.tabelle').show();
          var soccerMatchTableRows = data.soccerMatchTableRows;
          if(soccerMatchTableRows.length > 0){
            for(let a=0; a<soccerMatchTableRows.length; a++){
              let soccerMatchTableRow = soccerMatchTableRows[a];
              var active_class = '';
              var rank = soccerMatchTableRow.rank;
              var lastRank = soccerMatchTableRow.lastRank;
  
              form = soccerMatchTableRow.matchesWon - soccerMatchTableRow.matchesLost;
              if (form > 0) {
                  form_text = 'S';
                  form_class = 'up';
              } else if (form == 0) {
                  if (soccerMatchTableRow.matchesDrawn == 0) {
                      form_text = '-';
                      form_class = '';
                  }
                  if (soccerMatchTableRow.matchesDrawn > 0) {
                      form_text = 'U';
                      form_class = '';
                  }
              } else {
                  form_text = 'N';
                  form_class = 'down';
              }
              
              if (soccerMatchTableRow.contestantCode == 'FCZ') {
                  active_class = 'fc-zurich-highlight-row';
              }
  
              if(soccerMatchTableRow.logo != null){
                var logo = '<span class="team-img"><img src="'+soccerMatchTableRow.logo+'" alt="'+soccerMatchTableRow.contestantName+'" loading="lazy" width="26" height="26"></span>';
              }else{
                var logo = '';
              }
  
              table_html += '<div class="tabelle-row ' + active_class + '">';
              table_html += '<div class="th-1">' + rank + '</div>';
              table_html += '<div class="th-2"><span class="' + form_class + '"></span>'+logo + soccerMatchTableRow.contestantName + '</div>';
              table_html += '<div class="th-3">' + soccerMatchTableRow.matchesPlayed + '</div>';
              table_html += '<div class="th-4">' + soccerMatchTableRow.matchesWon + '</div>';
              table_html += '<div class="th-5">' + soccerMatchTableRow.matchesDrawn + '</div>';
              table_html += '<div class="th-6">' + soccerMatchTableRow.matchesLost + '</div>';
              table_html += '<div class="th-7">' + soccerMatchTableRow.goalsFor + '</div>';
              table_html += '<div class="th-8">' + soccerMatchTableRow.goalsAgainst + '</div>';
              table_html += '<div class="th-9">' + soccerMatchTableRow.goalDifference + '</div>';
              table_html += '<div class="th-10">' + form_text + '</div>';
              table_html += '<div class="th-11">' + soccerMatchTableRow.points + '</div>';
              table_html += '</div>';
            } // end for
            $('.tab-pane-content-tabelle .tabelle-content').html(table_html);
          } // end if
        }else{
          $('.match-center-tabs li.tabelle').hide();
        }
         
      });
    }
  
    var matchdaymatchesAPI = {
        "url": API_URL+'match-center/soccer-matches/'+matchID+'/match-day-matches',
        "method": "GET",
        "timeout": 0,
        "headers": {
            "Authorization": AUTH,
            "Content-Type": "application/json"
        }
    };
  
    $.ajax(matchdaymatchesAPI).done(function(response) {
      // console.log('match-by-matchdata');
      // spielplan - data  
      var data = response.data;
      var html = '';
      var d2 = new Date();
      if(data != null){
        var matchDay = data.matches;
        if(matchDay.length > 0){
          for (var mp = 0; mp < matchDay.length; mp++) { 
            var today_withzone = changeTimeZone(new Date(), 'Europe/Zurich');                
            var PlannedKickoffTime_withzone = changeTimeZone(new Date(matchDay[mp].date), 'Europe/Zurich'); 
         
            var PlannedKickoffTime = new Date(matchDay[mp].date);                 
            var hours = Math.abs(d2 - PlannedKickoffTime) / 36e5;
            
            if(today_withzone <= PlannedKickoffTime_withzone){                 
              var score = 'VS';
            } else {                  
              if(matchDay[mp].score == "" || matchDay[mp].score == null){
               var score = 'VS';
              }else {
                var score = matchDay[mp].score;
              }
            }
              
            html += '<div class="match-block" data-order="'+ hours +'">';
            html += '<div class="match-main-inner">';
           
            html += '<div class="match-date-wrapper">';
            html += '<div class="date">' + formatDateStringfor_match(matchDay[mp].date) + '</div>';
            
            if(matchDay[mp].arenaName != "" && matchDay[mp].arenaName != null){  
              html += '<div class="match-type">';
              html += matchDay[mp].arenaName;               
              html += '</div>';
            }
            html += '</div>';
            html += '<div class="match-wrapper-inner">';
            html += '<div class="team-1 home_team">';
            
            if(matchDay[mp].homeClub.logo != "" && matchDay[mp].homeClub.logo != null){
              //var imagesrc = image_default_path+matchDay[mp].HomeTeamLogo;
              var imagesrc = matchDay[mp].homeClub.logo;
              html += '<div class="team-img">';
              html += '<img class="lazy" srcset="'+imagesrc+'" alt="" loading="lazy">';
              html += '</div>';
            }
            html += '<h2 class="team-name">' + matchDay[mp].homeClub.name + '</h2>';
            html += '</div>';
            html += '<div class="team-score-wrapper">';                
             
            html += '<div class="team-score">' + score + '</div>';                
            html += '</div>';
            html += '<div class="team-2">';
            
            if(matchDay[mp].guestClub.logo != "" && matchDay[mp].guestClub.logo != null){
              //var imagesrc = image_default_path+matchDay[mp].GuestTeamLogo;
              var imagesrc = matchDay[mp].guestClub.logo;
              html += '<div class="team-img">';
              html += '<img class="lazy" srcset="'+imagesrc+'" alt="" loading="lazy">';
              html += '</div>';
            }
            html += '<h2 class="team-name">' + matchDay[mp].guestClub.name + '</h2>';
            html += '</div>';
            html += '</div>';
            
            html += '</div>';              
            html += '</div>';
          }
          $('.tab-pane-content-spieltag .next-match-inner').html(html);
  
          $(".tab-pane-content-spieltag .next-match-inner").html($('.tab-pane-content-spieltag .next-match-inner .match-block').sort(function(x, y) {
             var value_x = $(x).data('order');
             var arr_x = [];
             arr_x = value_x
                  
             var value_y = $(y).data('order');
             var arr_y = [];
             arr_y = value_y
          
             var arel = parseInt( arr_x);
             var brel = parseInt(arr_y);             
          
            return arel > brel ? -1 : 1;
          })); 
                  
          var btn_html = '';
          btn_html += '<div class="center">';            
          btn_html += '<a class="button button--primary" href="/pages/spielplan">'+spielbutton[lang]+'</a>';
          btn_html += '</div>';
          $(btn_html).insertAfter('.tab-pane-content-spieltag .next-match-inner');
        }else{
          $('.match-center-tabs li.spieltag').hide();
        }
        
      }else{
        if(details == '' || details == null){
          $('.match-center-tabs li.spieltag').hide();
        }
        
      }
    });
  //}
  
  // Future Match & SFL 
  if (match_date_final >= today && data.sflId != null && data.optaId == null) {
    console.log('Future Match & SFL');

    // add text when no player data
    if ((homeClubLineup == null || homeClubLineup == "") && (guestClubLineup == null || guestClubLineup == "")) {
      if ($('.tab-pane-content-aufstellung .slick-aufstellung').hasClass('slick-initialized')) {
          $('.slick-aufstellung').slick('destroy');
      }
      $('.tab-pane-content-aufstellung .slick-aufstellung-mobile .slick-dots').children('li').hide();
      $('.tab-pane-content-aufstellung .slick-aufstellung-mobile .slick-dots').children('li:lt(2)').show();
      $('.tab-pane-content-aufstellung .ersatzbank-home').remove();
      $('.tab-pane-content-aufstellung .ersatzbank-guest').remove();
      $('.tab-pane-content-aufstellung .aufstellung-main.aufstellung').css('align-items', 'flex-start');
      $('.tab-pane-content-aufstellung .aufstellung-main.aufstellung .aufstellung-head').text('Sobald die Aufstellung bekannt ist, wird diese angezeigt.');
      $('.tab-pane-content-aufstellung .aufstellung-center').hide();
    }
 

    // spielplan - data                  
    if(details != null){
      var html = '';
      var d2 = new Date();               
      var matchDay = details.MatchesPerMatchDay;
      if(matchDay.length > 0){
        for (var mp = 0; mp < matchDay.length; mp++) {            
          if(matchDay[mp].CompetitionName == "SUI Super league"){

            if(matchDay[mp].CompetitionName == "SUI Super league"){
              var CompetitionName = "SUI Super League";
            }else {
              var CompetitionName = matchDay[mp].CompetitionName;
            }                

            
            var image_default_path = 'https://aicofcz.s3.eu-central-1.amazonaws.com/'; 
            
            var today_withzone = changeTimeZone(new Date(), 'Europe/Zurich');                
            var PlannedKickoffTime_withzone = changeTimeZone(new Date(matchDay[mp].PlannedKickoffTime), 'Europe/Zurich');                
              
            var PlannedKickoffTime = new Date(matchDay[mp].PlannedKickoffTime);                 
            var hours = Math.abs(d2 - PlannedKickoffTime) / 36e5;
              
            
            if(today_withzone <= PlannedKickoffTime_withzone){                 
              var score = 'VS';
            } else {                  
              if(matchDay[mp].Score == "" || matchDay[mp].Score == null){
               var score = 'VS';
              }else {
                var score = matchDay[mp].Score;
              }
            }
                               
            html += '<div class="match-block" data-order="'+ hours +'">';
            html += '<div class="match-main-inner">';
           
            html += '<div class="match-date-wrapper">';
            html += '<div class="date">' + formatDateStringforsflmatch(matchDay[mp].PlannedKickoffTime) + '</div>';
            if(matchDay[mp].StadiumName != "" && matchDay[mp].StadiumName != null){  
            html += '<div class="match-type">';
            html += matchDay[mp].StadiumName;               
            html += '</div>';
            }  
            html += '</div>';
            html += '<div class="match-wrapper-inner">';
            html += '<div class="team-1">';
            if(matchDay[mp].HomeTeamLogo != "" && matchDay[mp].HomeTeamLogo != null){
            //var imagesrc = image_default_path+matchDay[mp].HomeTeamLogo;
            var imagesrc = matchDay[mp].HomeTeamLogo;
            html += '<div class="team-img">';
            html += '<img class="lazy" srcset="'+imagesrc+'" alt="" loading="lazy">';
            html += '</div>';
            }               
            html += '<h2 class="team-name">' + matchDay[mp].HomeTeamName + '</h2>';
            html += '</div>';
            html += '<div class="team-score-wrapper">';  
            
            html += '<div class="team-score">' + score + '</div>';                
            html += '</div>';
            html += '<div class="team-2">';
            if(matchDay[mp].GuestTeamLogo != "" && matchDay[mp].GuestTeamLogo != null){
            //var imagesrc = image_default_path+matchDay[mp].GuestTeamLogo;
            var imagesrc = matchDay[mp].GuestTeamLogo;
            html += '<div class="team-img">';
            html += '<img class="lazy" srcset="'+imagesrc+'" alt="" loading="lazy">';
            html += '</div>';
            }
            html += '<h2 class="team-name">' + matchDay[mp].GuestTeamName + '</h2>';
            html += '</div>';
            html += '</div>';
            
            html += '</div>';              
            html += '</div>';
            
          }
        }

        $('.tab-pane-content-spieltag .next-match-inner').html(html);

        $(".tab-pane-content-spieltag .next-match-inner").html($('.tab-pane-content-spieltag .next-match-inner .match-block').sort(function(x, y) {
          var value_x = $(x).data('order');
          var arr_x = [];
          arr_x = value_x
          
          var value_y = $(y).data('order');
          var arr_y = [];
          arr_y = value_y
          
          var arel = parseInt( arr_x);
          var brel = parseInt(arr_y);             
          
          return arel > brel ? -1 : 1;
        })); 
              
        var btn_html = '';
        btn_html += '<div class="center">';
        btn_html += '<a class="button button--primary" href="/pages/spielplan">'+spielbutton[lang]+'</a>';
        btn_html += '</div>';
        $(btn_html).insertAfter('.tab-pane-content-spieltag .next-match-inner'); 
      }
      else {
        $('.match-center-tabs li.spieltag').hide();
      }
    } // END IF of Details
    else {
      $('.match-center-tabs li.spieltag').hide();
    }
  }

  // Future Match & OPTA
  else if (match_date_final >= today && data.optaId != null) {
    console.log('Future Match & OPTA');
    $('.tab-pane-content-aufstellung .aufstellung-main .aufstellung-center').addClass('opta-matches'); 
    var soccerMatchDetail = data.soccerMatchDetail;
      
    if(soccerMatchDetail != null){
      var homeSoccerLineup = soccerMatchDetail.homeSoccerLineup;
      var guestSoccerLineup = soccerMatchDetail.guestSoccerLineup;

      // AUFSTELLUNG
      if(homeSoccerLineup != null && homeSoccerLineup != ''){
        var hometeam_lineup_players_html = '',
            hometeam_betch_players_html = '',
            hometeam_lineup_players_pos_html = '';
        
        let formation = homeSoccerLineup.formation;
        if(formation != null && formation != ''){
          let mainFormation = '';
          for(let f=0;f<formation.length;f++){
            if(f!=(formation.length-1)){
              var saperator = '-'
            }else{
              var saperator = '';
            }
            mainFormation += formation[f]+saperator;
          }
          $('.home-team-formation').text(mainFormation);
          $(".team-one-player-list").addClass('formation-'+mainFormation);
        }  

        if(homeSoccerLineup.trainer != null && homeSoccerLineup.trainer != ''){
          $('.aufstellung-head .home-team-trainer').html(homeSoccerLineup.trainer);
        }else{
          $('.aufstellung-head').hide();
        }
        
        if(homeSoccerLineup.lineupPlayers.length > 0){
          
          for(let a=0; a<homeSoccerLineup.lineupPlayers.length;a++){
            let lineupPlayer = homeSoccerLineup.lineupPlayers[a],
                shirtNo = lineupPlayer.shirtNumber,
                playerName = lineupPlayer.lastName;
            

            if(lineupPlayer.isTeamCaptain == true ){
              var leader = '(c)';
              var order = 0;
            }
            else{
              var leader = '';
              var order = shirtNo;
            }

            
            if(lineupPlayer.isBenched == false){
              var tooltipPosition = '';
              if(a == 0){
                tooltipPosition = ' tooltipbottom';
              }
              
              hometeam_lineup_players_html += '<li style="order:' + order + '">' + shirtNo + '  ' + playerName + ' ' + leader + ' <span class="inout_wrap"></span></li>';
              hometeam_lineup_players_pos_html += '<span data-order="'+lineupPlayer.formationPlace+'" class="plyr p' +lineupPlayer.formationPlace+' position--'+convertToSlug(lineupPlayer.position)+' positionSide--'+convertToSlug(lineupPlayer.positionSide)+'">' 
              hometeam_lineup_players_pos_html += '<span class="playertooltip'+tooltipPosition+'"><span class="playertooltiptext">'+playerName+'</span></span>';
              hometeam_lineup_players_pos_html += shirtNo;
              hometeam_lineup_players_pos_html += '</span>';
            }else{
              hometeam_betch_players_html += '<li style="order:' + order + '">' + shirtNo + '  ' + playerName + ' ' + leader + ' <span class="inout_wrap"></span></li>';
            }
          }
          $('.aufstellung-main.aufstellung ul.aufstellung-list-1').html(hometeam_lineup_players_html);
          $('.aufstellung-main.ersatzbank-home ul.aufstellung-list-1').html(hometeam_lineup_players_html);
          $('.ersatzbank-home ul.ersatzbank-list-1').html(hometeam_betch_players_html);

          $('.aufstellung-main.aufstellung .lineup-field-wrapper .team-one-player-list').html(hometeam_lineup_players_pos_html);
          // $('.aufstellung-main.ersatzbank-home .lineup-field-wrapper .team-one-player-list').html(hometeam_lineup_players_pos_html);
        }
        
      } // if homeSoccerLineup

      if(guestSoccerLineup != null && guestSoccerLineup != ''){
        var guest_lineup_players_html = '',
            guest_betch_players_html = '',
            guest_lineup_players_pos_html = '';
        
        let formation = guestSoccerLineup.formation;
        if(formation != null && formation != ''){
          let mainFormation = '';
          for(let f=0;f<formation.length;f++){
            if(f!=(formation.length-1)){
              var saperator = '-'
            }else{
              var saperator = '';
            }
            mainFormation += formation[f]+saperator;
          }
          $('.guest-team-formation').text(mainFormation);
          $(".team-two-player-list").addClass('formation-'+mainFormation);
        }  

        if(guestSoccerLineup.trainer != null && guestSoccerLineup.trainer != ''){
          $('.aufstellung-head .home-team-trainer').html(guestSoccerLineup.trainer);
        }else{
          $('.aufstellung-head').hide();
        }
        
        if(guestSoccerLineup.lineupPlayers.length > 0){
          for(let a=0; a<guestSoccerLineup.lineupPlayers.length;a++){
            let lineupPlayer = guestSoccerLineup.lineupPlayers[a];
            let shirtNo = lineupPlayer.shirtNumber;
            let playerName = lineupPlayer.lastName;

            if(lineupPlayer.isTeamCaptain == true ){
              var leader = '(c)';
              var order = 0;
            }
            else{
              var leader = '';
              var order = shirtNo;
            }          
            
            if(lineupPlayer.isBenched == false){                
              guest_lineup_players_html += '<li style="order:' + order + '">' + shirtNo + '  ' + playerName + ' ' + leader + ' <span class="inout_wrap"></span></li>';
              guest_lineup_players_pos_html += '<span data-order="'+lineupPlayer.formationPlace+'" class="plyr p' + (a+1)+' position--'+convertToSlug(lineupPlayer.position)+' positionSide--'+convertToSlug(lineupPlayer.positionSide)+' '+playerGoal+' '+playerCard+'">' 
              guest_lineup_players_pos_html += '<span class="playertooltip"><span class="playertooltiptext">'+playerName+'</span></span>';
              guest_lineup_players_pos_html += shirtNo;
              guest_lineup_players_pos_html += '</span>';
            }else{
              guest_betch_players_html += '<li style="order:' + order + '">' + shirtNo + '  ' + playerName + ' ' + leader + ' <span class="inout_wrap"></span></li>';
            }
          }
          $('.aufstellung-main.aufstellung ul.aufstellung-list-2').html(guest_lineup_players_html);
          $('.aufstellung-main.ersatzbank-guest ul.aufstellung-list-2').html(guest_lineup_players_html);
          $('.ersatzbank-guest ul.ersatzbank-list-2').html(guest_betch_players_html);

          $('.aufstellung-main.aufstellung .lineup-field-wrapper .team-two-player-list').html(guest_lineup_players_pos_html);
          $('.aufstellung-main.ersatzbank-guest .lineup-field-wrapper .team-two-player-list').html(guest_lineup_players_pos_html);
          
        }
        
      } // if guestSoccerLineup

      if (homeSoccerLineup == null || homeSoccerLineup == "" && guestSoccerLineup == null || guestSoccerLineup == "") {
          if ($('.tab-pane-content-aufstellung .slick-aufstellung').hasClass('slick-initialized')) {
              $('.slick-aufstellung').slick('destroy');
          }
          $('.tab-pane-content-aufstellung .slick-aufstellung-mobile .slick-dots').children('li').hide();
          $('.tab-pane-content-aufstellung .slick-aufstellung-mobile .slick-dots').children('li:lt(2)').show();
          $('.tab-pane-content-aufstellung .ersatzbank-home').remove();
          $('.tab-pane-content-aufstellung .ersatzbank-guest').remove();
          $('.tab-pane-content-aufstellung .aufstellung-main.aufstellung').css('align-items', 'flex-start');
          $('.tab-pane-content-aufstellung .aufstellung-main.aufstellung .aufstellung-head').text('Sobald die Aufstellung bekannt ist, wird diese angezeigt.');
          $('.tab-pane-content-aufstellung .aufstellung-center').hide();
      }
    }
  }
  // Future Match & Non-SFL
  else if (match_date_final >= today && data.sflId == null) {
    console.log('Future Match & Non-SFL');
      
      $('.match-center-tabs li.tabelle').hide();
      $('.match-center-tabs li.statistik').hide();
      $('.match-center-tabs li.spieltag').hide();

      // add text when no player data
      if ((homeClubLineup == null || homeClubLineup == "") && (guestClubLineup == null || guestClubLineup == "")) {
          if ($('.tab-pane-content-aufstellung .slick-aufstellung').hasClass('slick-initialized')) {
              $('.slick-aufstellung').slick('destroy');
          }
          $('.tab-pane-content-aufstellung .slick-aufstellung-mobile .slick-dots').children('li').hide();
          $('.tab-pane-content-aufstellung .slick-aufstellung-mobile .slick-dots').children('li:lt(2)').show();
          $('.tab-pane-content-aufstellung .ersatzbank-home').remove();
          $('.tab-pane-content-aufstellung .ersatzbank-guest').remove();
          $('.tab-pane-content-aufstellung .aufstellung-main.aufstellung').css('align-items', 'flex-start');
          $('.tab-pane-content-aufstellung .aufstellung-main.aufstellung .aufstellung-head').text('Sobald die Aufstellung bekannt ist, wird diese angezeigt.');                
          $('.tab-pane-content-aufstellung .aufstellung .aufstellung-center').remove();
          //$('.tab-pane-content-aufstellung .ersatzbank-home .aufstellung-center').remove();
          //$('.tab-pane-content-aufstellung .ersatzbank-guest .aufstellung-center').remove();
          //$('.tab-pane-content-aufstellung .slick-aufstellung').addClass('slick-aufstellung-center');
      }
  } else {
    
    // OLD Matches
    // OPTA match
    // if(/*(data.sflId == null || data.sflId == '') &&*/ (data.optaId != null && data.optaId != '')){
    if((data.optaId != null ) && (data.sflId == null )){
      console.log('Past Match & OPTA');
      $('.tab-pane-content-aufstellung .aufstellung-main .aufstellung-center').addClass('opta-matches'); 
      var soccerMatchDetail = data.soccerMatchDetail;
      
      if(soccerMatchDetail != null){
        var homeSoccerLineup = soccerMatchDetail.homeSoccerLineup;
        var guestSoccerLineup = soccerMatchDetail.guestSoccerLineup;

        // Goal
        var goalEvents = soccerMatchDetail.goalEvents,
            cardEvents = soccerMatchDetail.cardEvents,
            teamHome = '',
            teamGuest = '';
        
        var goals = [];
        if(goalEvents != null){
          for(let g=0;g<goalEvents.length; g++){
            let goalEvent = goalEvents[g];
            var itemGoals = {};
            itemGoals['playerName'] = goalEvent.scorerName;
            goals.push(itemGoals);
            
            if(goalEvent.isHomeClub == true){
              teamHome += '<div class="highlight" style="order:' + goalEvent.goalTimeMin + '"><div class="highlight__type"><span class="live__icon live__icon--goal"></span></div><div class="highlight__player"><strong>' + goalEvent.scorerName + '</strong> (' + goalEvent.goalTimeMin + '.)</div></div>';
            }else{
              teamGuest += '<div class="highlight" style="order:' + goalEvent.goalTimeMin + '"><div class="highlight__type"><span class="live__icon live__icon--goal"></span></div><div class="highlight__player"><strong>' + goalEvent.scorerName + '</strong> (' + goalEvent.goalTimeMin + '.)</div></div>';
            }
          }
        }

        var cards = [];
        if(cardEvents != null){
          for(let c=0; c<cardEvents.length; c++){
            let cardEvent = cardEvents[c],
                cartType = '',
                itemCards = {};
            if(cardEvent.type == 'YC'){
              cartType = 'yellowcard';
              itemCards['card']="yellow-card";
            }
            if(cardEvent.type == 'RC'){
              cartType = 'redcard';
              itemCards['card']="red-card";
            }
            if(cardEvent.type == 'YRC' || cardEvent.type == 'Y2C'){
              cartType = 'yellowredcard';
              itemCards['card']="red-yellow-card";
            }

            itemCards['playerName']=cardEvent.playerName;
            cards.push(itemCards);
            
            if(cardEvent.isHomeClub == true){
              teamHome += '<div class="highlight" style="order:' + cardEvent.cardTimeMin + '"><div class="highlight__type"><span class="live__icon live__icon--'+cartType+'"></span></div><div class="highlight__player"><strong>' + cardEvent.playerName + '</strong> (' + cardEvent.cardTimeMin + '.)</div></div>';
            }else{
              teamGuest += '<div class="highlight" style="order:' + cardEvent.cardTimeMin + '"><div class="highlight__type"><span class="live__icon live__icon--'+cartType+'"></span></div><div class="highlight__player"><strong>' + cardEvent.playerName + '</strong> (' + cardEvent.cardTimeMin + '.)</div></div>';
            }
          }
        }
        $('.live__highlights .team-1').html(teamHome);
        $('.live__highlights .team-2').html(teamGuest);
        
        var substitutionEvents = soccerMatchDetail.substitutionEvents;
        var teamA = [];
        var teamB = [];
        if(substitutionEvents != null){
          for(let s=0; s<substitutionEvents.length; s++){
            var substitutionEvent = substitutionEvents[s];
            if(substitutionEvent.isHomeClub == true){
              let teamItem = {};
              teamItem['playerInName'] = substitutionEvent.playerOnName;
              teamItem['playeroutName'] = substitutionEvent.playerOffName;
              teamItem['playerIN'] ='<span class="inout">'+substitutionEvent.substitutionTimeMin+'.</span>';
              teamA.push(teamItem);
            }else{
              let teamItem = {};
              teamItem['playerInName'] = substitutionEvent.playerOnName;
              teamItem['playeroutName'] = substitutionEvent.playerOffName;
              teamItem['playerIN'] ='<span class="inout">'+substitutionEvent.substitutionTimeMin+'.</span>';
              teamB.push(teamItem);
            }
          }
        }
        
        // AUFSTELLUNG
        if(homeSoccerLineup != null && homeSoccerLineup != ''){
          var hometeam_lineup_players_html = '',
              hometeam_betch_players_html = '',
              hometeam_lineup_players_pos_html = '';
          
          let formation = homeSoccerLineup.formation;
          if(formation != null && formation != ''){
            let mainFormation = '';
            for(let f=0;f<formation.length;f++){
              if(f!=(formation.length-1)){
                var saperator = '-'
              }else{
                var saperator = '';
              }
              mainFormation += formation[f]+saperator;
            }
            $('.home-team-formation').text(mainFormation);
            $(".team-one-player-list").addClass('formation-'+mainFormation);
          }  
  
          if(homeSoccerLineup.trainer != null && homeSoccerLineup.traine != ''){
            $('.aufstellung-head .home-team-trainer').html(homeSoccerLineup.trainer);
          }else{
            $('.aufstellung-head').hide();
          }
          
          if(homeSoccerLineup.lineupPlayers.length > 0){
            
            for(let a=0; a<homeSoccerLineup.lineupPlayers.length;a++){
              let lineupPlayer = homeSoccerLineup.lineupPlayers[a],
                  shirtNo = lineupPlayer.shirtNumber,
                  playerName = lineupPlayer.lastName;
              

              if(lineupPlayer.isTeamCaptain == true ){
                var leader = '(c)';
                var order = 0;
              }
              else{
                var leader = '';
                var order = shirtNo;
              }

              let playerIN = '', 
                  playerOut = '',
                  playerExchanged = '',
                  playerGoal = '',
                  playerCard = '';
              if(teamA.length > 0){
                for(let a=0; a<teamA.length;a++){
                  if(teamA[a].playeroutName == lineupPlayer.matchName){
                    playerOut = teamA[a].playerIN;
                    playerExchanged = 'yes';
                  }
                  if(teamA[a].playerInName == lineupPlayer.matchName){
                    playerIN = teamA[a].playerIN;
                  }
                }
              }

              if(goals.length > 0){
                for(let a=0;a<goals.length; a++){
                  if(goals[a].playerName == lineupPlayer.matchName){
                    playerGoal = 'player-goal';
                  }
                }
              }

              if(cards.length > 0){
                for(let a=0; a<cards.length;a++){
                  if(cards[a].playerName == lineupPlayer.matchName){
                    playerCard = cards[a].card;
                  }
                }
              }
              if(lineupPlayer.isBenched == false){
                var tooltipPosition = '';
                if(a == 0){
                  tooltipPosition = ' tooltipbottom';
                }
                
                hometeam_lineup_players_html += '<li style="order:' + order + '">' + shirtNo + '  ' + playerName + ' ' + leader + ' <span class="inout_wrap">'+playerOut+'</span></li>';
                hometeam_lineup_players_pos_html += '<span data-order="'+lineupPlayer.formationPlace+'" class="plyr p' +lineupPlayer.formationPlace+' position--'+convertToSlug(lineupPlayer.position)+' positionSide--'+convertToSlug(lineupPlayer.positionSide)+' '+playerGoal+' '+playerCard+'">' 
                hometeam_lineup_players_pos_html += '<span class="playertooltip'+tooltipPosition+'"><span class="playertooltiptext">'+playerName+'</span></span>';
                hometeam_lineup_players_pos_html += shirtNo;
                if(playerExchanged != ''){
                  hometeam_lineup_players_pos_html += '<span class="player-exchange"></span>';
                }
                hometeam_lineup_players_pos_html += '</span>';
              }else{
                hometeam_betch_players_html += '<li style="order:' + order + '">' + shirtNo + '  ' + playerName + ' ' + leader + ' <span class="inout_wrap">'+playerIN+'</span></li>';
              }
            }
            $('.aufstellung-main.aufstellung ul.aufstellung-list-1').html(hometeam_lineup_players_html);
            $('.aufstellung-main.ersatzbank-home ul.aufstellung-list-1').html(hometeam_lineup_players_html);
            $('.ersatzbank-home ul.ersatzbank-list-1').html(hometeam_betch_players_html);

            $('.aufstellung-main.aufstellung .lineup-field-wrapper .team-one-player-list').html(hometeam_lineup_players_pos_html);
            // $('.aufstellung-main.ersatzbank-home .lineup-field-wrapper .team-one-player-list').html(hometeam_lineup_players_pos_html);

            /*$(".aufstellung-main.aufstellung .lineup-field-wrapper .team-one-player-list").html($('.aufstellung-main.aufstellung .lineup-field-wrapper .team-one-player-list .plyr').sort(function(x, y) {
               var value_x = $(x).data('order');
               var arr_x = [];
               arr_x = value_x
                    
               var value_y = $(y).data('order');
               var arr_y = [];
               arr_y = value_y
       
               var arel = parseInt( arr_x);
               var brel = parseInt(arr_y);             
          
              return arel < brel ? -1 : 1;
           }));*/
            
          }
          
        } // if homeSoccerLineup

        if(guestSoccerLineup != null && guestSoccerLineup != ''){
          var guest_lineup_players_html = '',
              guest_betch_players_html = '',
              guest_lineup_players_pos_html = '';
          
          let formation = guestSoccerLineup.formation;
          if(formation != null && formation != ''){
            let mainFormation = '';
            for(let f=0;f<formation.length;f++){
              if(f!=(formation.length-1)){
                var saperator = '-'
              }else{
                var saperator = '';
              }
              mainFormation += formation[f]+saperator;
            }
            $('.guest-team-formation').text(mainFormation);
            $(".team-two-player-list").addClass('formation-'+mainFormation);
          }  
  
          if(guestSoccerLineup.trainer != null && guestSoccerLineup.traine != ''){
            $('.aufstellung-head .home-team-trainer').html(guestSoccerLineup.trainer);
          }else{
            $('.aufstellung-head').hide();
          }
          
          if(guestSoccerLineup.lineupPlayers.length > 0){
            for(let a=0; a<guestSoccerLineup.lineupPlayers.length;a++){
              let lineupPlayer = guestSoccerLineup.lineupPlayers[a];
              let shirtNo = lineupPlayer.shirtNumber;
              let playerName = lineupPlayer.lastName;

              if(lineupPlayer.isTeamCaptain == true ){
                var leader = '(c)';
                var order = 0;
              }
              else{
                var leader = '';
                var order = shirtNo;
              }

              let playerIN = '', 
                  playerOut = '',
                  playerExchanged = '',
                  playerGoal = '',
                  playerCard = '';
              
              if(teamB.length > 0){
                for(let a=0; a<teamB.length;a++){
                  if(teamB[a].playeroutName == lineupPlayer.matchName){
                    playerOut = teamB[a].playerIN;
                    playerExchanged = 'yes';
                  }
                  if(teamB[a].playerInName == lineupPlayer.matchName){
                    playerIN = teamB[a].playerIN;
                  }
                }
              }

              if(goals.length > 0){
                for(let a=0;a<goals.length; a++){
                  if(goals[a].playerName == lineupPlayer.matchName){
                    playerGoal = 'player-goal';
                  }
                }
              }

              if(cards.length > 0){
                for(let a=0; a<cards.length;a++){
                  if(cards[a].playerName == lineupPlayer.matchName){
                    playerCard = cards[a].card;
                  }
                }
              }
              
              if(lineupPlayer.isBenched == false){                
                guest_lineup_players_html += '<li style="order:' + order + '">' + shirtNo + '  ' + playerName + ' ' + leader + ' <span class="inout_wrap">'+playerOut+'</span></li>';
                guest_lineup_players_pos_html += '<span data-order="'+lineupPlayer.formationPlace+'" class="plyr p' + (a+1)+' position--'+convertToSlug(lineupPlayer.position)+' positionSide--'+convertToSlug(lineupPlayer.positionSide)+' '+playerGoal+' '+playerCard+'">' 
                guest_lineup_players_pos_html += '<span class="playertooltip"><span class="playertooltiptext">'+playerName+'</span></span>';
                guest_lineup_players_pos_html += shirtNo;
                if(playerExchanged != ''){
                  guest_lineup_players_pos_html += '<span class="player-exchange"></span>';
                }
                guest_lineup_players_pos_html += '</span>';
              }else{
                guest_betch_players_html += '<li style="order:' + order + '">' + shirtNo + '  ' + playerName + ' ' + leader + ' <span class="inout_wrap">'+playerIN+'</span></li>';
              }
            }
            $('.aufstellung-main.aufstellung ul.aufstellung-list-2').html(guest_lineup_players_html);
            $('.aufstellung-main.ersatzbank-guest ul.aufstellung-list-2').html(guest_lineup_players_html);
            $('.ersatzbank-guest ul.ersatzbank-list-2').html(guest_betch_players_html);

            $('.aufstellung-main.aufstellung .lineup-field-wrapper .team-two-player-list').html(guest_lineup_players_pos_html);
            $('.aufstellung-main.ersatzbank-guest .lineup-field-wrapper .team-two-player-list').html(guest_lineup_players_pos_html);
            
          }
          
        } // if guestSoccerLineup

        if (homeSoccerLineup == null || homeSoccerLineup == "" && guestSoccerLineup == null || guestSoccerLineup == "") {
            if ($('.tab-pane-content-aufstellung .slick-aufstellung').hasClass('slick-initialized')) {
                $('.slick-aufstellung').slick('destroy');
            }
            $('.tab-pane-content-aufstellung .slick-aufstellung-mobile .slick-dots').children('li').hide();
            $('.tab-pane-content-aufstellung .slick-aufstellung-mobile .slick-dots').children('li:lt(2)').show();
            $('.tab-pane-content-aufstellung .ersatzbank-home').remove();
            $('.tab-pane-content-aufstellung .ersatzbank-guest').remove();
            $('.tab-pane-content-aufstellung .aufstellung-main.aufstellung').css('align-items', 'flex-start');
            $('.tab-pane-content-aufstellung .aufstellung-main.aufstellung .aufstellung-head').text('Sobald die Aufstellung bekannt ist, wird diese angezeigt.');
            $('.tab-pane-content-aufstellung .aufstellung-center').hide();
        }

        // STATISTIK
        let homeSoccerMatchStatistic = soccerMatchDetail.homeSoccerMatchStatistic,
            guestSoccerMatchStatistic = soccerMatchDetail.guestSoccerMatchStatistic;
        
        if((homeSoccerMatchStatistic == null && homeSoccerMatchStatistic == '') && (guestSoccerMatchStatistic == null && guestSoccerMatchStatistic == '')){
          $('.match-center-tabs .statistik').hide();
        }else{
          // Tore
          var HomeTeamStatistics_tore = homeSoccerMatchStatistic.goals;
          var HomeTeamStatistics_tore = (HomeTeamStatistics_tore != null ) ? HomeTeamStatistics_tore : 0;
        
          var GuestTeamStatistics_tore = guestSoccerMatchStatistic.goals;
          var GuestTeamStatistics_tore = (GuestTeamStatistics_tore != null) ? GuestTeamStatistics_tore : 0;
        
          var tore_progressbar = (parseInt(HomeTeamStatistics_tore) / (parseInt(HomeTeamStatistics_tore) + parseInt(GuestTeamStatistics_tore))) * 100;
          //console.log('Tore',HomeTeamStatistics_tore,GuestTeamStatistics_tore,tore_progressbar);
          tore_progressbar = parseInt(tore_progressbar) || 0;
          $('.tab-pane-content-statistik .tore .statistik-content-team1').text(HomeTeamStatistics_tore);
          $('.tab-pane-content-statistik .tore .js-progressbar-item').attr('style', 'width:' + Math.round(tore_progressbar) + '%');
          $('.tab-pane-content-statistik .tore .statistik-content-team2').text(GuestTeamStatistics_tore);
    
          // Schüsse
          var HomeTeamStatistics_schusse = homeSoccerMatchStatistic.totalScoringAtt;
          HomeTeamStatistics_schusse = (HomeTeamStatistics_schusse != null) ? HomeTeamStatistics_schusse : 0;
        
          var GuestTeamStatistics_schusse = guestSoccerMatchStatistic.totalScoringAtt;
          GuestTeamStatistics_schusse = (GuestTeamStatistics_schusse != null ) ? GuestTeamStatistics_schusse : 0;
        
          var schusse_progressbar = (parseInt(HomeTeamStatistics_schusse) / (parseInt(HomeTeamStatistics_schusse) + parseInt(GuestTeamStatistics_schusse))) * 100;
          schusse_progressbar = parseInt(schusse_progressbar) || 0;
          $('.tab-pane-content-statistik .ShotsAtGoalSum .statistik-content-team1').text(HomeTeamStatistics_schusse);
          $('.tab-pane-content-statistik .ShotsAtGoalSum .js-progressbar-item').attr('style', 'width:' + Math.round(schusse_progressbar) + '%');
          $('.tab-pane-content-statistik .ShotsAtGoalSum .statistik-content-team2').text(GuestTeamStatistics_schusse);
    
          // Gehalten
          var HomeTeamStatistics_gehalten = homeSoccerMatchStatistic.saves;
          HomeTeamStatistics_gehalten = (HomeTeamStatistics_gehalten != null) ? HomeTeamStatistics_gehalten : 0;
        
          var GuestTeamStatistics_gehalten = guestSoccerMatchStatistic.saves;
          GuestTeamStatistics_gehalten = (GuestTeamStatistics_gehalten != null) ? GuestTeamStatistics_gehalten : 0
        
          $('.tab-pane-content-statistik .ShotsAtGoalHeld .statistik-content-team1').text(HomeTeamStatistics_gehalten);
          $('.tab-pane-content-statistik .ShotsAtGoalHeld .statistik-content-team2').text(GuestTeamStatistics_gehalten);
    
    
          // Torumrandung                   
          var HomeTeamStatistics_torumrandung = (homeSoccerMatchStatistic.hitWoodwork != null) ? homeSoccerMatchStatistic.hitWoodwork : 0;                  
          var GuestTeamStatistics_torumrandung = (guestSoccerMatchStatistic.hitWoodwork != null) ? guestSoccerMatchStatistic.hitWoodwork : 0;
          $('.tab-pane-content-statistik .Torumrandung .statistik-content-team1').text(HomeTeamStatistics_torumrandung);
          $('.tab-pane-content-statistik .Torumrandung .statistik-content-team2').text(GuestTeamStatistics_torumrandung);
    
          // Neben das Tor
          var HomeTeamStatistics_neben_das_tor = homeSoccerMatchStatistic.shotOffTarget;
          HomeTeamStatistics_neben_das_tor = (HomeTeamStatistics_neben_das_tor != null) ? HomeTeamStatistics_neben_das_tor : 0;
        
          var GuestTeamStatistics_neben_das_tor = guestSoccerMatchStatistic.shotOffTarget;
          GuestTeamStatistics_neben_das_tor = (GuestTeamStatistics_neben_das_tor != null) ? GuestTeamStatistics_neben_das_tor : 0;
          
          $('.tab-pane-content-statistik .ShotsAtGoalWide .statistik-content-team1').text(HomeTeamStatistics_neben_das_tor);
          $('.tab-pane-content-statistik .ShotsAtGoalWide .statistik-content-team2').text(GuestTeamStatistics_neben_das_tor);
    
          // Geblockt
          var HomeTeamStatistics_geblockt = homeSoccerMatchStatistic.blockedScoringAtt;
          HomeTeamStatistics_geblockt = (HomeTeamStatistics_geblockt != null) ? HomeTeamStatistics_geblockt : 0;
        
          var GuestTeamStatistics_geblockt = guestSoccerMatchStatistic.blockedScoringAtt;
          GuestTeamStatistics_geblockt = (GuestTeamStatistics_geblockt != null) ? GuestTeamStatistics_geblockt : 0;
        
          $('.tab-pane-content-statistik .ShotsAtGoalBlocked .statistik-content-team1').text(HomeTeamStatistics_geblockt);
          $('.tab-pane-content-statistik .ShotsAtGoalBlocked .statistik-content-team2').text(GuestTeamStatistics_geblockt);
    
          /*// Missglückt
          var HomeTeamStatistics_missgluckt = details.HomeTeamStatistics.ShotsAtGoalOther;
          HomeTeamStatistics_missgluckt = (HomeTeamStatistics_missgluckt != null) ? HomeTeamStatistics_missgluckt : 0;
        
          var GuestTeamStatistics_missgluckt = details.GuestTeamStatistics.ShotsAtGoalOther;
          GuestTeamStatistics_missgluckt = (GuestTeamStatistics_missgluckt != null) ? GuestTeamStatistics_missgluckt : 0;*/

          let HomeTeamStatistics_missgluckt = 0,
              GuestTeamStatistics_missgluckt = 0;
        
          $('.tab-pane-content-statistik .ShotsAtGoalOther .statistik-content-team1').text(HomeTeamStatistics_missgluckt);
          $('.tab-pane-content-statistik .ShotsAtGoalOther .statistik-content-team2').text(GuestTeamStatistics_missgluckt);
          $('.tab-pane-content-statistik .ShotsAtGoalOther').hide();
    
          // Ballbesitz
          var HomeTeamStatistics_ballbesitz = (homeSoccerMatchStatistic.possessionPercentage != null)?Math.round(homeSoccerMatchStatistic.possessionPercentage):0;
          var GuestTeamStatistics_ballbesitz = (guestSoccerMatchStatistic.possessionPercentage != null)?Math.round(guestSoccerMatchStatistic.possessionPercentage):0;
          $('.tab-pane-content-statistik .BallPossessionRatio .statistik-content-team1').text(HomeTeamStatistics_ballbesitz + '%');
          $('.tab-pane-content-statistik .BallPossessionRatio .js-progressbar-item').attr('style', 'width:' + HomeTeamStatistics_ballbesitz + '%');
          $('.tab-pane-content-statistik .BallPossessionRatio .statistik-content-team2').text(GuestTeamStatistics_ballbesitz + '%');
    
          // Corners
          var HomeTeamStatistics_corners = (homeSoccerMatchStatistic.wonCorners != null) ? homeSoccerMatchStatistic.wonCorners : 0;
          var GuestTeamStatistics_corners = (guestSoccerMatchStatistic.wonCorners != null) ? guestSoccerMatchStatistic.wonCorners : 0;
          var corners_progressbar = (parseInt(HomeTeamStatistics_corners) / (parseInt(HomeTeamStatistics_corners) + parseInt(GuestTeamStatistics_corners))) * 100;
          corners_progressbar = parseInt(corners_progressbar) || 0;
          $('.tab-pane-content-statistik .CornerKicksSum .statistik-content-team1').text(HomeTeamStatistics_corners);
          $('.tab-pane-content-statistik .CornerKicksSum .js-progressbar-item').attr('style', 'width:' + Math.round(corners_progressbar) + '%');
          $('.tab-pane-content-statistik .CornerKicksSum .statistik-content-team2').text(GuestTeamStatistics_corners);
    
          // Offsides
          var HomeTeamStatistics_offsides = (homeSoccerMatchStatistic.totalOffside != null) ? homeSoccerMatchStatistic.totalOffside : 0;
          var GuestTeamStatistics_offsides = (guestSoccerMatchStatistic.totalOffside != null) ? guestSoccerMatchStatistic.totalOffside : 0;
          var offsides_progressbar = (parseInt(HomeTeamStatistics_offsides) / (parseInt(HomeTeamStatistics_offsides) + parseInt(GuestTeamStatistics_offsides))) * 100;
          offsides_progressbar = parseInt(offsides_progressbar) || 0;
          $('.tab-pane-content-statistik .Offsides .statistik-content-team1').text(HomeTeamStatistics_offsides);
          $('.tab-pane-content-statistik .Offsides .js-progressbar-item').attr('style', 'width:' + Math.round(offsides_progressbar) + '%');
          $('.tab-pane-content-statistik .Offsides .statistik-content-team2').text(GuestTeamStatistics_offsides);
    
          // Flanken
          var HomeTeamStatistics_flanken = (homeSoccerMatchStatistic.totalCross != null) ? homeSoccerMatchStatistic.totalCross : 0;
          var GuestTeamStatistics_flanken = (guestSoccerMatchStatistic.totalCross != null) ? guestSoccerMatchStatistic.totalCross : 0 ;
          var flanken_progressbar = (parseInt(HomeTeamStatistics_flanken) / (parseInt(HomeTeamStatistics_flanken) + parseInt(GuestTeamStatistics_flanken))) * 100;
          flanken_progressbar = parseInt(flanken_progressbar) || 0;
          $('.tab-pane-content-statistik .CrossesSum .statistik-content-team1').text(HomeTeamStatistics_flanken);
          $('.tab-pane-content-statistik .CrossesSum .js-progressbar-item').attr('style', 'width:' + Math.round(flanken_progressbar) + '%');
          $('.tab-pane-content-statistik .CrossesSum .statistik-content-team2').text(GuestTeamStatistics_flanken);
    
          // Penaltys getreten
          var HomeTeamStatistics_penaltys = (homeSoccerMatchStatistic.penaltyWon != null) ? homeSoccerMatchStatistic.penaltyWon : 0;
          var GuestTeamStatistics_penaltys = (guestSoccerMatchStatistic.penaltyWon != null) ? guestSoccerMatchStatistic.penaltyWon : 0;
          var penaltys_progressbar = (parseInt(HomeTeamStatistics_penaltys) / (parseInt(HomeTeamStatistics_penaltys) + parseInt(GuestTeamStatistics_penaltys))) * 100;
          penaltys_progressbar = parseInt(penaltys_progressbar) || 0;
          $('.tab-pane-content-statistik .PenaltiesSum .statistik-content-team1').text(HomeTeamStatistics_penaltys);
          $('.tab-pane-content-statistik .PenaltiesSum .js-progressbar-item').attr('style', 'width:' + Math.round(penaltys_progressbar) + '%');
          $('.tab-pane-content-statistik .PenaltiesSum .statistik-content-team2').text(GuestTeamStatistics_penaltys);
    
          // Begangene Fouls
          var HomeTeamStatistics_Fouls = (homeSoccerMatchStatistic.fkFoulLost != null) ? homeSoccerMatchStatistic.fkFoulLost : 0;
          var GuestTeamStatistics_Fouls = (guestSoccerMatchStatistic.fkFoulLost != null) ? guestSoccerMatchStatistic.fkFoulLost : 0;
          var Fouls_progressbar = (parseInt(HomeTeamStatistics_Fouls) / (parseInt(HomeTeamStatistics_Fouls) + parseInt(GuestTeamStatistics_Fouls))) * 100;
          Fouls_progressbar = parseInt(Fouls_progressbar) || 0;
          $('.tab-pane-content-statistik .FoulsAgainstOpponent .statistik-content-team1').text(HomeTeamStatistics_Fouls);
          $('.tab-pane-content-statistik .FoulsAgainstOpponent .js-progressbar-item').attr('style', 'width:' + Math.round(Fouls_progressbar) + '%');
          $('.tab-pane-content-statistik .FoulsAgainstOpponent .statistik-content-team2').text(GuestTeamStatistics_Fouls);
    
    
          // Karten - Gelb
          var HomeTeamStatistics_Karten_Gelb = (homeSoccerMatchStatistic.totalYellowCard != null) ? homeSoccerMatchStatistic.totalYellowCard : 0;
          var GuestTeamStatistics_Karten_Gelb = (guestSoccerMatchStatistic.totalYellowCard != null) ? guestSoccerMatchStatistic.totalYellowCard : 0;
          $('.tab-pane-content-statistik .CardsYellow .statistik-content-team1').text(HomeTeamStatistics_Karten_Gelb);
          $('.tab-pane-content-statistik .CardsYellow .statistik-content-team2').text(GuestTeamStatistics_Karten_Gelb);
    
          // Karten - Gelb-Rot
          var HomeTeamStatistics_Karten_Gelb_rot = (homeSoccerMatchStatistic.secondYellow != null) ? homeSoccerMatchStatistic.secondYellow : 0;
          var GuestTeamStatistics_Karten_Gelb_rot = (guestSoccerMatchStatistic.secondYellow != null) ? guestSoccerMatchStatistic.secondYellow : 0;
          $('.tab-pane-content-statistik .CardsYellowRed .statistik-content-team1').text(HomeTeamStatistics_Karten_Gelb_rot);
          $('.tab-pane-content-statistik .CardsYellowRed .statistik-content-team2').text(GuestTeamStatistics_Karten_Gelb_rot);
    
          // Karten - Rot
          var HomeTeamStatistics_Karten_rot = (homeSoccerMatchStatistic.totalRedCard != null) ? homeSoccerMatchStatistic.totalRedCard : 0;
          var GuestTeamStatistics_Karten_rot = (guestSoccerMatchStatistic.totalRedCard != null) ? guestSoccerMatchStatistic.totalRedCard : 0;
          $('.tab-pane-content-statistik .CardsRed .statistik-content-team1').text(HomeTeamStatistics_Karten_rot);
          $('.tab-pane-content-statistik .CardsRed .statistik-content-team2').text(GuestTeamStatistics_Karten_rot);
        }
      }
    }
      
    // non-sfl match
    else if((data.optaId == null || data.optaId == '') && (data.sflId == '' || data.sflId == null )){
      //  OLD Matches & NON-SFL
      console.log('Past Match & Non-SFL');              

      $('.match-center-tabs li.statistik').hide();
      // $('.match-center-tabs li.spieltag').hide();

      if (gender == 'WOMEN' && soccerLeague == "Meisterschaft AWSL") { 
         $('.match-center-tabs li.tabelle').show();
         $('.tab-content .tab-pane-content-tabelle-men').hide();
         $('.tab-content .tab-pane-content-tabelle-frauen').removeClass('hidden');
      }else {
        $('.match-center-tabs li.tabelle').hide();
      }

      /*if ($('.tab-pane-content-aufstellung .slick-aufstellung').hasClass('slick-initialized')) {
       $('.slick-aufstellung').slick('destroy');
      }
      $('.tab-pane-content-aufstellung .ersatzbank-home').remove();
      $('.tab-pane-content-aufstellung .ersatzbank-guest').remove();*/

      $('.tab-pane-content-aufstellung .aufstellung .aufstellung-center').remove();
      //$('.tab-pane-content-aufstellung .ersatzbank-home .aufstellung-center').remove();                
      //$('.tab-pane-content-aufstellung .ersatzbank-guest .aufstellung-center').remove();
      //$('.tab-pane-content-aufstellung .slick-aufstellung').addClass('slick-aufstellung-center');


      if ((homeClubLineup == null || homeClubLineup == "") && (guestClubLineup == null || guestClubLineup == "")) {
          $('.match-center-tabs li.aufstellung').hide();
      }

    } else {

      console.log('Past Match & SFL');
      if(details != null){
  
        $('.tab-pane-content-aufstellung .aufstellung-main .aufstellung-center').addClass('sfl-matches'); 
          
        // console.log(response);
        //  OLD Matches & SFL
        
        var Season = details.Season;
        var homeTeamLogo = details.HomeTeamLogo;
        var guestTeamLogo = details.GuestTeamLogo;
        var matchDate = details.StartDate;
        var matchDay = details.MatchDay;
        var hometeam = details.HomeTeamName;
        var guestteam = details.GuestTeamName;
        var result = details.Score;
        // console.log(details.MatchesPerMatchDay);
    
        if (details.Highlights.EventsBasicExtended != null) {
          var teamA = '';
          var teamB = '';
          var Substitution = [];
          var homeTeamgoal = '',
              guestTeamgoal = '',
              homeTeamRed = '',
              guestTeamRed = '',
              homeTeamYellow = '',
              guestTeamYellow = '',
              homeTeamRedYellow = '',
              guestTeamRedYellow = '';
          
          if(details.Highlights.EventsBasicExtended.GameSection!=undefined && details.Highlights.EventsBasicExtended.GameSection!=null){
            if( typeof details.Highlights.EventsBasicExtended.GameSection.length == 'undefined'){
              if(typeof details.Highlights.EventsBasicExtended.GameSection.Substitutions !== 'undefined'){      
                Substitution.push(details.Highlights.EventsBasicExtended.GameSection.Substitutions.Substitution);
              }
    
              if (typeof details.Highlights.EventsBasicExtended.GameSection.ShotAtGoals !== 'undefined') {
                var ShotAtGoal = details.Highlights.EventsBasicExtended.GameSection.ShotAtGoals.ShotAtGoal;
                var ShotAtGoalLength = ShotAtGoal.length; 
                
                for (var b = 0; b < ShotAtGoalLength; b++) {
                  if (ShotAtGoal[b]['@attributes'].ShotResult == 'SuccessfulShot') {
                    var PlayerAlias = ShotAtGoal[b]['@attributes'].PlayerAlias;
                    var Players_name = PlayerAlias.split(" "); 
                    
                    if(Players_name.length == 1 ){
                      var Players_final = Players_name[0];
                    } else {
                      var Players_final = Players_name[1];
                    } 
                    var PlayerLastName = ShotAtGoal[b]['@attributes'].PlayerLastName;
                    var MinuteOfPlay = ShotAtGoal[b]['@attributes'].MinuteOfPlay;                
                    if (ShotAtGoal[b]['@attributes'].TeamRole == 'home') {
                      homeTeamgoal += Players_final + ', ';
                      teamA += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--goal"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                      if (typeof MinuteOfPlay !== 'undefined') {
                        teamA += '(' + MinuteOfPlay + ')'; 
                      }
                      teamA += '</div></div>';
                    } else {
                      guestTeamgoal += Players_final + ', ';
                      teamB += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--goal"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                      if (typeof MinuteOfPlay !== 'undefined') {
                        teamB += '(' + MinuteOfPlay + ')'; 
                      }
                      teamB += '</div></div>';
                    }
                  }
                }
              }
    
              if(typeof details.Highlights.EventsBasicExtended.GameSection.Cards !== 'undefined'){
                var cardTotal = details.Highlights.EventsBasicExtended.GameSection.Cards.Card.length;
    
                if (typeof cardTotal === 'undefined') {
                  var PlayerAlias = details.Highlights.EventsBasicExtended.GameSection.Cards.Card['@attributes'].PlayerAlias;
                  var Players_name = PlayerAlias.split(" ");                               
                  if(Players_name.length == 1 ){
                    var Players_final = Players_name[0];
                  } else {
                    var Players_final = Players_name[1];
                  } 
                  
                  var PlayerLastName = details.Highlights.EventsBasicExtended.GameSection.Cards.Card['@attributes'].PlayerLastName; 
                  var MinuteOfPlay = details.Highlights.EventsBasicExtended.GameSection.Cards.Card['@attributes'].MinuteOfPlay;
                  var cardColor = details.Highlights.EventsBasicExtended.GameSection.Cards.Card['@attributes'].CardColor;
                  if (details.Highlights.EventsBasicExtended.GameSection.Cards.Card['@attributes'].TeamRole == 'home') {
                    if(cardColor == 'yellowRed'){
                      homeTeamRedYellow += Players_final + ', ';
                    }else if(cardColor == 'red'){
                      homeTeamRed += Players_final + ', ';
                    }else if(cardColor == 'yellow'){
                      homeTeamYellow += Players_final + ', ';
                    }
                      teamA += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--' + cardColor.toLowerCase() + 'card"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                      if (typeof MinuteOfPlay !== 'undefined') {
                      teamA += '(' + MinuteOfPlay + ')'; 
                      }
                      teamA += '</div></div>';
                  } else {
                    if(cardColor == 'yellowRed'){
                      guestTeamRedYellow += Players_final + ', ';
                    }else if(cardColor == 'red'){
                      guestTeamRed += Players_final + ', ';
                    }else if(cardColor == 'yellow'){
                      guestTeamYellow += Players_final + ', ';
                    }
                      teamB += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--' + cardColor.toLowerCase() + 'card"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                      if (typeof MinuteOfPlay !== 'undefined') {
                      teamB += '(' + MinuteOfPlay + ')'; 
                      }
                      teamB += '</div></div>';
                  }
    
                }else {
                  for (var c = 0; c < cardTotal; c++) { 
                    var PlayerAlias = details.Highlights.EventsBasicExtended.GameSection.Cards.Card[c]['@attributes'].PlayerAlias;
                    var Players_name = PlayerAlias.split(" ");                               
                    if(Players_name.length == 1 ){
                      var Players_final = Players_name[0];
                    } else {
                      var Players_final = Players_name[1];
                    } 
                    var PlayerLastName = details.Highlights.EventsBasicExtended.GameSection.Cards.Card[c]['@attributes'].PlayerLastName;
                    var MinuteOfPlay = details.Highlights.EventsBasicExtended.GameSection.Cards.Card[c]['@attributes'].MinuteOfPlay;
                    var cardColor = details.Highlights.EventsBasicExtended.GameSection.Cards.Card[c]['@attributes'].CardColor;
                    if (details.Highlights.EventsBasicExtended.GameSection.Cards.Card[c]['@attributes'].TeamRole == 'home') {
                      if(cardColor == 'yellowRed'){
                        homeTeamRedYellow += Players_final + ', ';
                      }else if(cardColor == 'red'){
                        homeTeamRed += Players_final + ', ';
                      }else if(cardColor == 'yellow'){
                        homeTeamYellow += Players_final + ', ';
                      }
                        teamA += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--' + cardColor.toLowerCase() + 'card"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                        if (typeof MinuteOfPlay !== 'undefined') {
                        teamA += '(' + MinuteOfPlay + ')'; 
                        }
                        teamA += '</div></div>';
                    } else {
                      if(cardColor == 'yellowRed'){
                        guestTeamRedYellow += Players_final + ', ';
                      }else if(cardColor == 'red'){
                        guestTeamRed += Players_final + ', ';
                      }else if(cardColor == 'yellow'){
                        guestTeamYellow += Players_final + ', ';
                      }
                        teamB += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--' + cardColor.toLowerCase() + 'card"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                        if (typeof MinuteOfPlay !== 'undefined') {
                        teamB += '(' + MinuteOfPlay + ')'; 
                        }
                        teamB += '</div></div>';
                    }
                  }
                }
              }
    
            }else{
              for (var a = 0; a < details.Highlights.EventsBasicExtended.GameSection.length; a++) {
    
                if(typeof details.Highlights.EventsBasicExtended.GameSection[a].Substitutions !== 'undefined'){
                   Substitution.push(details.Highlights.EventsBasicExtended.GameSection[a].Substitutions.Substitution);                           
                }
    
                if (typeof details.Highlights.EventsBasicExtended.GameSection[a].ShotAtGoals !== 'undefined') {
                  var ShotAtGoal = details.Highlights.EventsBasicExtended.GameSection[a].ShotAtGoals.ShotAtGoal;
                  var ShotAtGoalLength = ShotAtGoal.length;
                  for (var b = 0; b < ShotAtGoalLength; b++) {
                    if (ShotAtGoal[b]['@attributes'].ShotResult == 'SuccessfulShot') {
                      var PlayerAlias = ShotAtGoal[b]['@attributes'].PlayerAlias;
                      var Players_name = PlayerAlias.split(" ");                               
                      if(Players_name.length == 1 ){
                        var Players_final = Players_name[0];
                      } else {
                        var Players_final = Players_name[1];
                      }
                      var PlayerLastName = ShotAtGoal[b]['@attributes'].PlayerLastName;
                      var MinuteOfPlay = ShotAtGoal[b]['@attributes'].MinuteOfPlay;
                      if (ShotAtGoal[b]['@attributes'].TeamRole == 'home') {
                        homeTeamgoal += Players_final + ', ';
                          teamA += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--goal"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                          if (typeof MinuteOfPlay !== 'undefined') {
                          teamA += '(' + MinuteOfPlay + ')'; 
                          }
                          teamA += '</div></div>';
                      } else {
                        guestTeamgoal += Players_final + ', ';
                          teamB += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--goal"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                          if (typeof MinuteOfPlay !== 'undefined') {
                          teamB += '(' + MinuteOfPlay + ')'; 
                          }
                          teamB += '</div></div>';
                      }
                    }
                  }
                }
    
                if (typeof details.Highlights.EventsBasicExtended.GameSection[a].Cards !== 'undefined') {
    
                  var cardTotal = details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card.length;
                  
                  if (typeof cardTotal === 'undefined') {
                    var PlayerAlias = details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card['@attributes'].PlayerAlias;
                    var Players_name = PlayerAlias.split(" ");                               
                    if(Players_name.length == 1 ){
                      var Players_final = Players_name[0];
                    } else {
                      var Players_final = Players_name[1];
                    }
                    var PlayerLastName = details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card['@attributes'].PlayerLastName;
                    var MinuteOfPlay = details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card['@attributes'].MinuteOfPlay;
                    var cardColor = details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card['@attributes'].CardColor;
                    
                    if (details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card['@attributes'].TeamRole == 'home') {
                      if(cardColor == 'yellowRed'){
                        homeTeamRedYellow += Players_final + ', ';
                      }else if(cardColor == 'red'){
                        homeTeamRed += Players_final + ', ';
                      }else if(cardColor == 'yellow'){
                        homeTeamYellow += Players_final + ', ';
                      }
                                    
                      teamA += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--' + cardColor.toLowerCase() + 'card"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                      if (typeof MinuteOfPlay !== 'undefined') {
                      teamA += '(' + MinuteOfPlay + ')'; 
                      }
                      teamA += '</div></div>';
                    } else {
                      if(cardColor == 'yellowRed'){
                        guestTeamRedYellow += Players_final + ', ';
                      }else if(cardColor == 'red'){
                        guestTeamRed += Players_final + ', ';
                      }else if(cardColor == 'yellow'){
                        guestTeamYellow += Players_final + ', ';
                      }
                      teamB += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--' + cardColor.toLowerCase() + 'card"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                      if (typeof MinuteOfPlay !== 'undefined') {
                      teamB += '(' + MinuteOfPlay + ')'; 
                      }
                      teamB += '</div></div>';
                    }
                  } else {
                    for (var c = 0; c < cardTotal; c++) {
                      var PlayerAlias = details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card[c]['@attributes'].PlayerAlias;
                      var Players_name = PlayerAlias.split(" ");                               
                      if(Players_name.length == 1 ){
                        var Players_final = Players_name[0];
                      } else {
                        var Players_final = Players_name[1];
                      }
                      var PlayerLastName = details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card[c]['@attributes'].PlayerLastName;
                      var MinuteOfPlay = details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card[c]['@attributes'].MinuteOfPlay;
                      var cardColor = details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card[c]['@attributes'].CardColor;
                                    
                      if (details.Highlights.EventsBasicExtended.GameSection[a].Cards.Card[c]['@attributes'].TeamRole == 'home') {
                        if(cardColor == 'yellowRed'){
                          homeTeamRedYellow += Players_final + ', ';
                        }else if(cardColor == 'red'){
                          homeTeamRed += Players_final + ', ';
                        }else if(cardColor == 'yellow'){
                          homeTeamYellow += Players_final + ', ';
                        }
                        teamA += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--' + cardColor.toLowerCase() + 'card"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                        if (typeof MinuteOfPlay !== 'undefined') {
                        teamA += '(' + MinuteOfPlay + ')'; 
                        }
                        teamA += '</div></div>';
                      } else {
                        if(cardColor == 'yellowRed'){
                          guestTeamRedYellow += Players_final + ', ';
                        }else if(cardColor == 'red'){
                          guestTeamRed += Players_final + ', ';
                        }else if(cardColor == 'yellow'){
                          guestTeamYellow += Players_final + ', ';
                        }
                        teamB += '<div class="highlight sfl" data-order="' + MinuteOfPlay + '"><div class="highlight__type"><span class="live__icon live__icon--' + cardColor.toLowerCase() + 'card"></span></div><div class="highlight__player"><strong> ' + PlayerLastName + '</strong>';
                        if (typeof MinuteOfPlay !== 'undefined') {
                        teamB += '(' + MinuteOfPlay + ')'; 
                        }
                        teamB += '</div></div>';
                      }
                    }
                  }
                }
              }
            }
          }
        }
    
                
        $('.live__highlights .team-1').html(teamA);
        $('.live__highlights .team-2').html(teamB);
        
        $(".live__highlights .team-1").html($('.live__highlights .team-1 .highlight').sort(function(x, y) {
          var value_x = $(x).data('order');
          var arr_x = [];
          arr_x = value_x
        
          var value_y = $(y).data('order');
          var arr_y = [];
          arr_y = value_y
        
          var arel = parseInt(arr_x);
          var brel = parseInt(arr_y);
        
          return arel < brel ? -1 : 1;
        }));
        
        $(".live__highlights .team-2").html($('.live__highlights .team-2 .highlight').sort(function(x, y) {
          var value_x = $(x).data('order');
          var arr_x = [];
          arr_x = value_x
        
          var value_y = $(y).data('order');
          var arr_y = [];
          arr_y = value_y
        
          var arel = parseInt(arr_x);
          var brel = parseInt(arr_y);
        
          return arel < brel ? -1 : 1;
        }));
                  
        if (data.arenaName == null && data.arenaName == "") {
          if (details.StadiumAddress != null && details.StadiumName != null) {
              $('.tab-pane-content-matchcenter .live__matchinfo .stadium-wrapper').html('<span><strong>' + details.StadiumName + ', ' + details.StadiumAddress + '</strong></span>');
          } else if (details.StadiumAddress != null && details.StadiumName == null) {
              $('.tab-pane-content-matchcenter .live__matchinfo .stadium-wrapper').html('<span><strong>' + details.StadiumAddress + '</strong></span>');
          } else if (details.StadiumAddress == null && details.StadiumName != null) {
              $('.tab-pane-content-matchcenter .live__matchinfo .stadium-wrapper').html('<span><strong>' + details.StadiumName + '</strong></span>');
          }
        }
    
        if (data.numberOfSpectators == null) {
          if (details.NumberOfSpectators == null) {
              $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').hide();
          } else if (details.NumberOfSpectators == 0) {
              $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').hide();
          } else {
              $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').show();
              $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').html('<span> ' + details.NumberOfSpectators + ' '+ spectators[lang] +'</span>');
          }
        } else if (data.numberOfSpectators == 0) {                   
          if (details.NumberOfSpectators == null) {
              $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').hide();
          } else if (details.NumberOfSpectators == 0) {
              $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').hide();
          } else {     
              $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').show();
              $('.tab-pane-content-matchcenter .live__matchinfo .zuschauer-wrapper').html('<span> ' + details.NumberOfSpectators + ' '+ spectators[lang] +'</span>');                        
          }
        }
                
        if (data.refereeName == null && data.refereeName == "") {
            var referees = details.Referees;
            if (referees != null) {
                var refereeName = '';
                for (var r = 0; r < referees.length; r++) {
                    if (referees[r].role == 'referee') {
                        refereeName = referees[r].name;
                    }
                }
                $('.tab-pane-content-matchcenter .live__matchinfo .rafree-wrapper').show();
                $('.tab-pane-content-matchcenter .live__matchinfo .rafree-wrapper').html('<span><strong> '+ referee[lang] +': </strong> ' + refereeName + '</span>');
            } else {
                $('.tab-pane-content-matchcenter .live__matchinfo .rafree-wrapper').hide();
            }
        }
    
        var HomeTeamStatistics = details.HomeTeamStatistics;
        var GuestTeamStatistics = details.GuestTeamStatistics;
        if (HomeTeamStatistics == null && GuestTeamStatistics == null) {
            $('.match-center-tabs li.statistik').hide();
        } 
        else
        {
          // Tore
          var HomeTeamStatistics_tore = details.HomeTeamStatistics.ShotsAtGoalSuccessfull;
          var HomeTeamStatistics_tore = (HomeTeamStatistics_tore != null ) ? HomeTeamStatistics_tore : 0;
        
          var GuestTeamStatistics_tore = details.GuestTeamStatistics.ShotsAtGoalSuccessfull;
          var GuestTeamStatistics_tore = (GuestTeamStatistics_tore != null) ? GuestTeamStatistics_tore : 0;
        
          var tore_progressbar = (parseInt(HomeTeamStatistics_tore) / (parseInt(HomeTeamStatistics_tore) + parseInt(GuestTeamStatistics_tore))) * 100;
          //console.log('Tore',HomeTeamStatistics_tore,GuestTeamStatistics_tore,tore_progressbar);
          tore_progressbar = parseInt(tore_progressbar) || 0;
          $('.tab-pane-content-statistik .tore .statistik-content-team1').text(HomeTeamStatistics_tore);
          $('.tab-pane-content-statistik .tore .js-progressbar-item').attr('style', 'width:' + Math.round(tore_progressbar) + '%');
          $('.tab-pane-content-statistik .tore .statistik-content-team2').text(GuestTeamStatistics_tore);
    
          // Schüsse
          var HomeTeamStatistics_schusse = details.HomeTeamStatistics.ShotsAtGoalSum;
          HomeTeamStatistics_schusse = (HomeTeamStatistics_schusse != null) ? HomeTeamStatistics_schusse : 0;
        
          var GuestTeamStatistics_schusse = details.GuestTeamStatistics.ShotsAtGoalSum;
          GuestTeamStatistics_schusse = (GuestTeamStatistics_schusse != null ) ? GuestTeamStatistics_schusse : 0;
        
          var schusse_progressbar = (parseInt(HomeTeamStatistics_schusse) / (parseInt(HomeTeamStatistics_schusse) + parseInt(GuestTeamStatistics_schusse))) * 100;
          schusse_progressbar = parseInt(schusse_progressbar) || 0;
          $('.tab-pane-content-statistik .ShotsAtGoalSum .statistik-content-team1').text(HomeTeamStatistics_schusse);
          $('.tab-pane-content-statistik .ShotsAtGoalSum .js-progressbar-item').attr('style', 'width:' + Math.round(schusse_progressbar) + '%');
          $('.tab-pane-content-statistik .ShotsAtGoalSum .statistik-content-team2').text(GuestTeamStatistics_schusse);
    
          // Gehalten
          var HomeTeamStatistics_gehalten = details.HomeTeamStatistics.ShotsAtGoalHeld;
          HomeTeamStatistics_gehalten = (HomeTeamStatistics_gehalten != null) ? HomeTeamStatistics_gehalten : 0;
        
          var GuestTeamStatistics_gehalten = details.GuestTeamStatistics.ShotsAtGoalHeld;
          GuestTeamStatistics_gehalten = (GuestTeamStatistics_gehalten != null) ? GuestTeamStatistics_gehalten : 0
        
          $('.tab-pane-content-statistik .ShotsAtGoalHeld .statistik-content-team1').text(HomeTeamStatistics_gehalten);
          $('.tab-pane-content-statistik .ShotsAtGoalHeld .statistik-content-team2').text(GuestTeamStatistics_gehalten);
    
    
          // Torumrandung (ShotsAtGoalCrossbar + ShotsAtGoalPost)
          var homeShotsAtGoalCrossbar = (details.HomeTeamStatistics.ShotsAtGoalCrossbar != null) ? details.HomeTeamStatistics.ShotsAtGoalCrossbar : 0
          var homeShotsAtGoalPost = (details.HomeTeamStatistics.ShotsAtGoalPost != null) ? details.HomeTeamStatistics.ShotsAtGoalPost : 0;
          var guestShotsAtGoalCrossbar = (details.GuestTeamStatistics.ShotsAtGoalCrossbar != null) ? details.GuestTeamStatistics.ShotsAtGoalCrossbar : 0;
          var guestguestShotsAtGoalCrossbar = (details.GuestTeamStatistics.ShotsAtGoalPost != null) ? details.GuestTeamStatistics.ShotsAtGoalPost : 0;
        
          var HomeTeamStatistics_torumrandung = parseInt(homeShotsAtGoalCrossbar) + parseInt(homeShotsAtGoalPost);                  
          var GuestTeamStatistics_torumrandung = parseInt(guestShotsAtGoalCrossbar) + parseInt(guestguestShotsAtGoalCrossbar);
          $('.tab-pane-content-statistik .Torumrandung .statistik-content-team1').text(HomeTeamStatistics_torumrandung);
          $('.tab-pane-content-statistik .Torumrandung .statistik-content-team2').text(GuestTeamStatistics_torumrandung);
    
          // Neben das Tor
          var HomeTeamStatistics_neben_das_tor = details.HomeTeamStatistics.ShotsAtGoalWide;
          HomeTeamStatistics_neben_das_tor = (HomeTeamStatistics_neben_das_tor != null) ? HomeTeamStatistics_neben_das_tor : 0;
        
          var GuestTeamStatistics_neben_das_tor = details.GuestTeamStatistics.ShotsAtGoalWide;
          GuestTeamStatistics_neben_das_tor = (GuestTeamStatistics_neben_das_tor != null) ? GuestTeamStatistics_neben_das_tor : 0;
          
          $('.tab-pane-content-statistik .ShotsAtGoalWide .statistik-content-team1').text(HomeTeamStatistics_neben_das_tor);
          $('.tab-pane-content-statistik .ShotsAtGoalWide .statistik-content-team2').text(GuestTeamStatistics_neben_das_tor);
    
          // Geblockt
          var HomeTeamStatistics_geblockt = details.HomeTeamStatistics.ShotsAtGoalBlocked;
          HomeTeamStatistics_geblockt = (HomeTeamStatistics_geblockt != null) ? HomeTeamStatistics_geblockt : 0;
        
          var GuestTeamStatistics_geblockt = details.GuestTeamStatistics.ShotsAtGoalBlocked;
          GuestTeamStatistics_geblockt = (GuestTeamStatistics_geblockt != null) ? GuestTeamStatistics_geblockt : 0;
        
          $('.tab-pane-content-statistik .ShotsAtGoalBlocked .statistik-content-team1').text(HomeTeamStatistics_geblockt);
          $('.tab-pane-content-statistik .ShotsAtGoalBlocked .statistik-content-team2').text(GuestTeamStatistics_geblockt);
    
          // Missglückt
          var HomeTeamStatistics_missgluckt = details.HomeTeamStatistics.ShotsAtGoalOther;
          HomeTeamStatistics_missgluckt = (HomeTeamStatistics_missgluckt != null) ? HomeTeamStatistics_missgluckt : 0;
        
          var GuestTeamStatistics_missgluckt = details.GuestTeamStatistics.ShotsAtGoalOther;
          GuestTeamStatistics_missgluckt = (GuestTeamStatistics_missgluckt != null) ? GuestTeamStatistics_missgluckt : 0;
        
          $('.tab-pane-content-statistik .ShotsAtGoalOther .statistik-content-team1').text(HomeTeamStatistics_missgluckt);
          $('.tab-pane-content-statistik .ShotsAtGoalOther .statistik-content-team2').text(GuestTeamStatistics_missgluckt);
    
          // Ballbesitz
          var homeBallPossessionRatio = (details.HomeTeamStatistics.BallPossessionRatio != null) ? details.HomeTeamStatistics.BallPossessionRatio : 0;
          var guestBallPossessionRatio = (details.GuestTeamStatistics.BallPossessionRatio != null) ? details.GuestTeamStatistics.BallPossessionRatio : 0;
          var HomeTeamStatistics_ballbesitz = Math.round(homeBallPossessionRatio);
          var GuestTeamStatistics_ballbesitz = Math.round(guestBallPossessionRatio);
          $('.tab-pane-content-statistik .BallPossessionRatio .statistik-content-team1').text(HomeTeamStatistics_ballbesitz + '%');
          $('.tab-pane-content-statistik .BallPossessionRatio .js-progressbar-item').attr('style', 'width:' + HomeTeamStatistics_ballbesitz + '%');
          $('.tab-pane-content-statistik .BallPossessionRatio .statistik-content-team2').text(GuestTeamStatistics_ballbesitz + '%');
    
          // Corners
          var HomeTeamStatistics_corners = (details.HomeTeamStatistics.CornerKicksSum != null) ? details.HomeTeamStatistics.CornerKicksSum : 0;
          var GuestTeamStatistics_corners = (details.GuestTeamStatistics.CornerKicksSum != null) ? details.GuestTeamStatistics.CornerKicksSum : 0;
          var corners_progressbar = (parseInt(HomeTeamStatistics_corners) / (parseInt(HomeTeamStatistics_corners) + parseInt(GuestTeamStatistics_corners))) * 100;
          corners_progressbar = parseInt(corners_progressbar) || 0;
          $('.tab-pane-content-statistik .CornerKicksSum .statistik-content-team1').text(HomeTeamStatistics_corners);
          $('.tab-pane-content-statistik .CornerKicksSum .js-progressbar-item').attr('style', 'width:' + Math.round(corners_progressbar) + '%');
          $('.tab-pane-content-statistik .CornerKicksSum .statistik-content-team2').text(GuestTeamStatistics_corners);
    
          // Offsides
          var HomeTeamStatistics_offsides = (details.HomeTeamStatistics.Offsides != null) ? details.HomeTeamStatistics.Offsides : 0;
          var GuestTeamStatistics_offsides = (details.GuestTeamStatistics.Offsides != null) ? details.GuestTeamStatistics.Offsides : 0;
          var offsides_progressbar = (parseInt(HomeTeamStatistics_offsides) / (parseInt(HomeTeamStatistics_offsides) + parseInt(GuestTeamStatistics_offsides))) * 100;
          offsides_progressbar = parseInt(offsides_progressbar) || 0;
          $('.tab-pane-content-statistik .Offsides .statistik-content-team1').text(HomeTeamStatistics_offsides);
          $('.tab-pane-content-statistik .Offsides .js-progressbar-item').attr('style', 'width:' + Math.round(offsides_progressbar) + '%');
          $('.tab-pane-content-statistik .Offsides .statistik-content-team2').text(GuestTeamStatistics_offsides);
    
          // Flanken
          var HomeTeamStatistics_flanken = (details.HomeTeamStatistics.CrossesSum != null) ? details.HomeTeamStatistics.CrossesSum : 0;
          var GuestTeamStatistics_flanken = (details.GuestTeamStatistics.CrossesSum != null) ? details.GuestTeamStatistics.CrossesSum : 0 ;
          var flanken_progressbar = (parseInt(HomeTeamStatistics_flanken) / (parseInt(HomeTeamStatistics_flanken) + parseInt(GuestTeamStatistics_flanken))) * 100;
          flanken_progressbar = parseInt(flanken_progressbar) || 0;
          $('.tab-pane-content-statistik .CrossesSum .statistik-content-team1').text(HomeTeamStatistics_flanken);
          $('.tab-pane-content-statistik .CrossesSum .js-progressbar-item').attr('style', 'width:' + Math.round(flanken_progressbar) + '%');
          $('.tab-pane-content-statistik .CrossesSum .statistik-content-team2').text(GuestTeamStatistics_flanken);
    
          // Penaltys getreten
          var HomeTeamStatistics_penaltys = (details.HomeTeamStatistics.PenaltiesSum != null) ? details.HomeTeamStatistics.PenaltiesSum : 0;
          var GuestTeamStatistics_penaltys = (details.GuestTeamStatistics.PenaltiesSum != null) ? details.GuestTeamStatistics.PenaltiesSum : 0;
          var penaltys_progressbar = (parseInt(HomeTeamStatistics_penaltys) / (parseInt(HomeTeamStatistics_penaltys) + parseInt(GuestTeamStatistics_penaltys))) * 100;
          penaltys_progressbar = parseInt(penaltys_progressbar) || 0;
          $('.tab-pane-content-statistik .PenaltiesSum .statistik-content-team1').text(HomeTeamStatistics_penaltys);
          $('.tab-pane-content-statistik .PenaltiesSum .js-progressbar-item').attr('style', 'width:' + Math.round(penaltys_progressbar) + '%');
          $('.tab-pane-content-statistik .PenaltiesSum .statistik-content-team2').text(GuestTeamStatistics_penaltys);
    
          // Begangene Fouls
          var HomeTeamStatistics_Fouls = (details.HomeTeamStatistics.FoulsAgainstOpponent != null) ? details.HomeTeamStatistics.FoulsAgainstOpponent : 0;
          var GuestTeamStatistics_Fouls = (details.GuestTeamStatistics.FoulsAgainstOpponent != null) ? details.GuestTeamStatistics.FoulsAgainstOpponent : 0;
          var Fouls_progressbar = (parseInt(HomeTeamStatistics_Fouls) / (parseInt(HomeTeamStatistics_Fouls) + parseInt(GuestTeamStatistics_Fouls))) * 100;
          Fouls_progressbar = parseInt(Fouls_progressbar) || 0;
          $('.tab-pane-content-statistik .FoulsAgainstOpponent .statistik-content-team1').text(HomeTeamStatistics_Fouls);
          $('.tab-pane-content-statistik .FoulsAgainstOpponent .js-progressbar-item').attr('style', 'width:' + Math.round(Fouls_progressbar) + '%');
          $('.tab-pane-content-statistik .FoulsAgainstOpponent .statistik-content-team2').text(GuestTeamStatistics_Fouls);
    
    
          // Karten - Gelb
          var HomeTeamStatistics_Karten_Gelb = (details.HomeTeamStatistics.CardsYellow != null) ? details.HomeTeamStatistics.CardsYellow : 0;
          var GuestTeamStatistics_Karten_Gelb = (details.GuestTeamStatistics.CardsYellow != null) ? details.GuestTeamStatistics.CardsYellow : 0;
          $('.tab-pane-content-statistik .CardsYellow .statistik-content-team1').text(HomeTeamStatistics_Karten_Gelb);
          $('.tab-pane-content-statistik .CardsYellow .statistik-content-team2').text(GuestTeamStatistics_Karten_Gelb);
    
          // Karten - Gelb-Rot
          var HomeTeamStatistics_Karten_Gelb_rot = (details.HomeTeamStatistics.CardsYellowRed != null) ? details.HomeTeamStatistics.CardsYellowRed : 0;
          var GuestTeamStatistics_Karten_Gelb_rot = (details.GuestTeamStatistics.CardsYellowRed != null) ? details.GuestTeamStatistics.CardsYellowRed : 0;
          $('.tab-pane-content-statistik .CardsYellowRed .statistik-content-team1').text(HomeTeamStatistics_Karten_Gelb_rot);
          $('.tab-pane-content-statistik .CardsYellowRed .statistik-content-team2').text(GuestTeamStatistics_Karten_Gelb_rot);
    
          // Karten - Rot
          var HomeTeamStatistics_Karten_rot = (details.HomeTeamStatistics.CardsRed != null) ? details.HomeTeamStatistics.CardsRed : 0;
          var GuestTeamStatistics_Karten_rot = (details.GuestTeamStatistics.CardsRed != null) ? details.GuestTeamStatistics.CardsRed : 0;
          $('.tab-pane-content-statistik .CardsRed .statistik-content-team1').text(HomeTeamStatistics_Karten_rot);
          $('.tab-pane-content-statistik .CardsRed .statistik-content-team2').text(GuestTeamStatistics_Karten_rot);
    
        }
          
        //Matchcenter AUFSTELLUNG Tab                
        if (details.HomeTeam != null) {
    
          var hometeam_bench_players = details.HomeTeam.bench.players;
          var hometeam_lineup_players = details.HomeTeam.lineUp.players; 
    
          var hometeam_lineup_players_html = '';
          var hometeam_betch_players_html = '';
         
          for (var pl = 0; pl < hometeam_lineup_players.length; pl++) {
    
            if(hometeam_lineup_players[pl].teamLeader == 'true' ){
              var leader = '(c)';
              var order = 0;
            }
            else{
              var leader = '';
              var order = hometeam_lineup_players[pl].ShirtNumber;
            }
    
            var teamas ='';                    
            if(Substitution.length > 0){
              for(var s1=0;s1<Substitution.length;s1++){                    
                for(var s=0;s<Substitution[s1].length;s++){
                  var Sub_attributes = Substitution[s1][s]['@attributes'];
                  if(Sub_attributes.PlayerInAlias == hometeam_lineup_players[pl].ShortName){
                    if(Sub_attributes.TeamRole == 'home'){
                      var MinuteOfPlay_In = Sub_attributes.MinuteOfPlay;
                      if (typeof MinuteOfPlay_In !== 'undefined'){
                        teamas += '<span class="inout">'+MinuteOfPlay_In+'</span>';
                      }
                      else if(Sub_attributes.GameSection == "half") {
                        teamas += '<span class="inout">46.</span>';
                      }
                    }
                  }
                  if(Sub_attributes.PlayerOutAlias == hometeam_lineup_players[pl].ShortName){
                    if(Sub_attributes.TeamRole == 'home'){
                      var MinuteOfPlay_Out = Sub_attributes.MinuteOfPlay;
                      if (typeof MinuteOfPlay_Out !== 'undefined'){
                        teamas += '<span class="inout">'+MinuteOfPlay_Out+'</span>';
                      }
                      else if(Sub_attributes.GameSection == "half") {
                        teamas += '<span class="inout">46.</span>';
                      }
                    }               
                  }            
                }
              }
            }
    
            var ShortName = hometeam_lineup_players[pl].ShortName;
            var Players_name = ShortName.split(" ");                               
            if(Players_name.length == 1 ){
              var Players_final = Players_name[0];
            } else {
              var Players_final = Players_name[1];
            } 
    
            hometeam_lineup_players_html += '<li style="order:' + order + '">' + hometeam_lineup_players[pl].ShirtNumber + '  ' + Players_final + ' ' + leader + ' <span class="inout_wrap">' + teamas + '</span></li>';
          }
    
          $('.aufstellung-main.aufstellung ul.aufstellung-list-1').html(hometeam_lineup_players_html);
          $('.aufstellung-main.ersatzbank-home ul.aufstellung-list-1').html(hometeam_lineup_players_html);
    
          for (var hb = 0; hb < hometeam_bench_players.length; hb++) {
            var order = hometeam_bench_players[hb].ShirtNumber;
            var ShortName = hometeam_bench_players[hb].ShortName;
            var Players_name = ShortName.split(" ");    
            
            if(Players_name.length == 1 ){
              var Players_final = Players_name[0];
            } else {
              var Players_final = Players_name[1];
            } 
    
            var teamas ='';
            if(Substitution.length > 0){
              for(var s1=0;s1<Substitution.length;s1++){
                for(var s=0;s<Substitution[s1].length;s++){
                  var Sub_attributes = Substitution[s1][s]['@attributes'];
                  if(Sub_attributes.PlayerInAlias == hometeam_bench_players[hb].ShortName){                        
                    if(Sub_attributes.TeamRole == 'home'){
                      var MinuteOfPlay_In = Sub_attributes.MinuteOfPlay;
                      if (typeof MinuteOfPlay_In !== 'undefined'){
                        teamas += '<span class="inout">'+MinuteOfPlay_In+'</span>';
                      }
                      else if(Sub_attributes.GameSection == "half") {
                        teamas += '<span class="inout">46.</span>';
                      }
                    }
                  }
                  if(Sub_attributes.PlayerOutAlias == hometeam_bench_players[hb].ShortName){
                    if(Sub_attributes.TeamRole == 'home'){
                      var MinuteOfPlay_Out = Sub_attributes.MinuteOfPlay;
                      if (typeof MinuteOfPlay_Out !== 'undefined'){
                        teamas += '<span class="inout">'+MinuteOfPlay_Out+'</span>';
                      }
                      else if(Sub_attributes.GameSection == "half") {
                        teamas += '<span class="inout">46.</span>';
                      }
                    }               
                  }            
                }
              }
            }
                      
            hometeam_betch_players_html += '<li style="order:' + order + '">' + hometeam_bench_players[hb].ShirtNumber + '  ' + Players_final + ' <span class="inout_wrap">' + teamas + '</span></li>';
          }
    
          $('.ersatzbank-home ul.ersatzbank-list-1').html(hometeam_betch_players_html);
    
    
          // Only for trainer & formation & position                             
          var hometeam_lineup_trainer = details.HomeTeam.lineUp.trainers;
          $('.aufstellung .aufstellung-head').show();
          $('.ersatzbank-home .aufstellung-head').show();
          $('.aufstellung-main.aufstellung .home-team-trainer').text(hometeam_lineup_trainer[0].ShortName);
          $('.aufstellung-main.ersatzbank-home .home-lineup-trainer').text(hometeam_lineup_trainer[0].ShortName);
    
          var hometeam_bench_trainer = details.HomeTeam.bench.trainers;
          //$('.aufstellung-main.ersatzbank-home .home-betch-trainer').text(hometeam_bench_trainer[0].ShortName);
          $('.aufstellung-main.ersatzbank-home .home-team-trainer').text(hometeam_bench_trainer[0].ShortName);
    
          var hometeam_lineup_formation = convertToSlug(details.HomeTeam.lineUp.formation);
          $('.aufstellung-main.aufstellung .lineup-field-wrapper .team-one-player-list').addClass("formation-"+hometeam_lineup_formation);
          $('.aufstellung-main.aufstellung .aufstellung-center .home-team-formation').text(details.HomeTeam.lineUp.formation);
    
          var hometeam_lineup_players = details.HomeTeam.lineUp.players;
          var hometeambenchPlayers = details.HomeTeam.bench.players;
                  
          var bpArray = [];
          for(var a=0; a<hometeambenchPlayers.length; a++){
            var benchplayer = hometeambenchPlayers[a]; 
            if(typeof benchplayer.substitutions != 'undefined'){
              if(benchplayer.substitutions.length > 0){
                for(var bp=0; bp<benchplayer.substitutions.length; bp++){
                  var bps = benchplayer.substitutions[bp];
                  var bpPlyr = {};
                  bpPlyr['benchPlayer'] = benchplayer.ShirtNumber;
                  bpPlyr['ShortName'] = benchplayer.ShortName;
                  bpPlyr['exchangedWith'] = bps.shirtNumber;
                  bpPlyr['playerOutAlias'] = bps.playerOutAlias;
      
                  bpArray.push(bpPlyr);
                }
              }
            }
          }
                  
          var hometeam_lineup_players_pos_html = '';
          for (var a = 0, b = 1; a < hometeam_lineup_players.length; a++, b++) {
            var Players_name = hometeam_lineup_players[a].ShortName.split(" ");                               
            if(Players_name.length == 1 ){
              var playerName = Players_name[0];
            } else {
              var playerName = Players_name[1];
            } 
            var playerfromStarting = hometeam_lineup_players[a].starting;
            if(playerfromStarting == 'false'){
              var playerExchanged = ' player-exchange';
            }else{
              var playerExchanged = '';
            }
      
            if(homeTeamgoal.indexOf(playerName) > -1){
              var playerGoal = ' player-goal';
            }else{
              var playerGoal = '';
            }
      
            var playerCard = '';
            if(homeTeamRedYellow.indexOf(playerName) > -1){
              playerCard = ' red-yellow-card';
            }else if(homeTeamYellow.indexOf(playerName) > -1){
              playerCard = ' yellow-card';
            }else if(homeTeamRed.indexOf(playerName) > -1){
              playerCard = ' red-card';
            }
            
            var shirtNo = hometeam_lineup_players[a].ShirtNumber;
            var playingPosition = convertToSlug(hometeam_lineup_players[a].playingPosition);
            var playerName = hometeam_lineup_players[a].ShortName.split(' ')[1];
            var exchangedPlayer = '';
            
            if(bpArray.length > 0){
              for(var aa=0;aa<bpArray.length;aa++){
                if(bpArray[aa].exchangedWith == shirtNo){
                  //shirtNo = bpArray[aa].benchPlayer;
                  //playerName = bpArray[aa].ShortName.split(' ')[1];
                  exchangedPlayer = bpArray[aa].exchangedWith+ ' ' +bpArray[aa].playerOutAlias;
                  playerExchanged = ' player-exchange';
      
                  if(homeTeamRedYellow.indexOf(playerName) > -1){
                    playerCard = ' red-yellow-card';
                  }else if(homeTeamYellow.indexOf(playerName) > -1){
                    playerCard = ' yellow-card';
                  }else if(homeTeamRed.indexOf(playerName) > -1){
                    playerCard = ' red-card';
                  }else{
                    playerCard = '';
                  }
      
                  if(homeTeamgoal.indexOf(playerName) > -1){
                    var playerGoal = ' player-goal';
                  }else{
                    var playerGoal = '';
                  }
                }
              }
            }
      
            var tooltipPosition = '';
            if(b == 1){
                tooltipPosition = 'tooltipbottom';
            }
            
            hometeam_lineup_players_pos_html += '<span class="plyr p' + b +playerGoal+playerCard+' plyr-'+ playingPosition +'">';
            hometeam_lineup_players_pos_html += '<span class="playertooltip '+tooltipPosition+'"><span class="playertooltiptext">'+playerName+'</span></span>';
            hometeam_lineup_players_pos_html += shirtNo;
            if(playerExchanged != ''){
              hometeam_lineup_players_pos_html += '<span class="player-exchange"></span>';
            }
            hometeam_lineup_players_pos_html += '</span>';
          }
          $('.aufstellung-main.aufstellung .lineup-field-wrapper .team-one-player-list').html(hometeam_lineup_players_pos_html);
      
        }
    
        if (details.GuestTeam != null) {
                  
          var guestteam_lineup_trainer = details.GuestTeam.lineUp.trainers;
          $('.ersatzbank-guest .aufstellung-head').show();
          $('.aufstellung-main.ersatzbank-guest .guest-lineup-trainer').text(guestteam_lineup_trainer[0].ShortName);
          $('.aufstellung-main.aufstellung  .guest-team-trainer').text(guestteam_lineup_trainer[0].ShortName);
          $('.aufstellung-main.ersatzbank-guest .guest-team-trainer').text(guestteam_lineup_trainer[0].ShortName);
    
          var guestteam_bench_trainer = details.GuestTeam.bench.trainers;
          //$('.aufstellung-main.ersatzbank-guest .guest-betch-trainer').text(guestteam_bench_trainer[0].ShortName);
    
          var guestteam_lineup_formation = convertToSlug(details.GuestTeam.lineUp.formation);
          $('.aufstellung-main.aufstellung .lineup-field-wrapper .team-two-player-list').addClass("formation-"+guestteam_lineup_formation);
          $('.aufstellung-main.aufstellung .aufstellung-center .guest-team-formation').text(details.GuestTeam.lineUp.formation);
    
          var guestteam_lineup_players = details.GuestTeam.lineUp.players;
          var guestteambenchPlayers = details.GuestTeam.bench.players;
          
          var gbpArray = [];
          for(var a=0; a<guestteambenchPlayers.length; a++){
            var gbenchplayer = guestteambenchPlayers[a];
            if(typeof gbenchplayer.substitutions != 'undefined'){
              if(gbenchplayer.substitutions.length > 0){
                for(var bp=0; bp<gbenchplayer.substitutions.length; bp++){
                  var bps = gbenchplayer.substitutions[bp];
                  //console.log(bps.shirtNumber);
                  var bpPlyr = {};
                  bpPlyr['benchPlayer'] = gbenchplayer.ShirtNumber;
                  bpPlyr['ShortName'] = gbenchplayer.ShortName;
                  bpPlyr['exchangedWith'] = bps.shirtNumber;
                  bpPlyr['playerOutAlias'] = bps.playerOutAlias;
                  gbpArray.push(bpPlyr);
                }
              }
            }
          }
    
            var guestteam_lineup_players_pos_html = '';
            for (var a = 0, b = 1; a < guestteam_lineup_players.length; a++, b++) {
              var Players_name = guestteam_lineup_players[a].ShortName.split(" ");                               
              if(Players_name.length == 1 ){
                var playerName = Players_name[0];
              } else {
                var playerName = Players_name[1];
              }
                                    
              var guestplayerfromStarting = guestteam_lineup_players[a].starting;
              if(guestplayerfromStarting == 'false'){
                var guestplayerExchanged = 'player-exchange';
              }else{
                var guestplayerExchanged = '';
              }
              if(guestTeamgoal.indexOf(playerName) > -1){
                var guestplayerGoal = ' player-goal';
              }else{
                var guestplayerGoal = '';
              }
            
              var guestplayercard = '';
              if(guestTeamRedYellow.indexOf(playerName) > -1){
                guestplayercard = ' red-yellow-card';
              }else if(guestTeamYellow.indexOf(playerName) > -1){
                guestplayercard = ' yellow-card';
              }else if(guestTeamRed.indexOf(playerName) > -1){
                guestplayercard = ' red-card';
              }
    
              var shirtNo = guestteam_lineup_players[a].ShirtNumber;
              var playingPosition = convertToSlug(guestteam_lineup_players[a].playingPosition);
              var playerName = guestteam_lineup_players[a].ShortName.split(' ')[1];
              var exchangedPlayer = '';
    
              if(gbpArray.length > 0){
                for(var aa=0;aa<gbpArray.length;aa++){
                  if(gbpArray[aa].exchangedWith == shirtNo){                              
                    //shirtNo = gbpArray[aa].benchPlayer;
                    //playerName = gbpArray[aa].ShortName.split(' ')[1];
                    exchangedPlayer = gbpArray[aa].exchangedWith+ ' ' +gbpArray[aa].playerOutAlias;
                    guestplayerExchanged = ' player-exchange';
    
                    if(guestTeamRedYellow.indexOf(playerName) > -1){
                      guestplayercard = ' red-yellow-card';
                    }else if(guestTeamYellow.indexOf(playerName) > -1){
                      guestplayercard = ' yellow-card';
                    }else if(guestTeamRed.indexOf(playerName) > -1){
                      guestplayercard = ' red-card';
                    }else{
                      guestplayercard = '';
                    }
    
                    if(guestTeamgoal.indexOf(playerName) > -1){
                      var guestplayerGoal = ' player-goal';
                    }else{
                      var guestplayerGoal = '';
                    }
                  }                            
                }
              }
              guestteam_lineup_players_pos_html += '<span class="plyr p' + b +guestplayerGoal+guestplayercard+' plyr-'+ playingPosition +'">';
              guestteam_lineup_players_pos_html += '<span class="playertooltip '+tooltipPosition+'"><span class="playertooltiptext">'+playerName+'</span></span>';
              guestteam_lineup_players_pos_html += shirtNo;
              if(guestplayerExchanged!=''){
                guestteam_lineup_players_pos_html += '<span class="player-exchange"></span>';
              }
              guestteam_lineup_players_pos_html += '</span>';
            }
            $('.aufstellung-main.aufstellung .lineup-field-wrapper .team-two-player-list').html(guestteam_lineup_players_pos_html);
                      
            var guestteam_bench_players = details.GuestTeam.bench.players;
            var guestteam_lineup_players = details.GuestTeam.lineUp.players;                    
    
            var guestteam_players_html = '';
            var guestteam_betch_players_html = '';
                
            for (var pl = 0; pl < guestteam_lineup_players.length; pl++) {
           
              if(guestteam_lineup_players[pl].teamLeader == 'true' ){
                var leader = '(c)';
                var order = 0;
              }
              else{
                var leader = '';
                var order = guestteam_lineup_players[pl].ShirtNumber;
              }
                      
              var teamas ='';
              if(Substitution.length > 0){
                for(var s1=0;s1<Substitution.length;s1++){
                  for(var s=0;s<Substitution[s1].length;s++){
                    var Sub_attributes = Substitution[s1][s]['@attributes'];
                    if(Sub_attributes.PlayerInAlias == guestteam_lineup_players[pl].ShortName){
                      if(Sub_attributes.TeamRole == 'guest'){
                        var MinuteOfPlay_In = Sub_attributes.MinuteOfPlay;
                        if (typeof MinuteOfPlay_In !== 'undefined'){
                          teamas += '<span class="inout">'+MinuteOfPlay_In+'</span>';                              
                        }
                        else if(Sub_attributes.GameSection == "half") {
                          teamas += '<span class="inout">46.</span>';
                        }
                      }
                    }
                    if(Sub_attributes.PlayerOutAlias == guestteam_lineup_players[pl].ShortName){
                      if(Sub_attributes.TeamRole == 'guest'){
                        var MinuteOfPlay_Out = Sub_attributes.MinuteOfPlay;
                        if (typeof MinuteOfPlay_Out !== 'undefined'){
                          teamas += '<span class="inout">'+MinuteOfPlay_Out+'</span>';                              
                        }
                        else if(Sub_attributes.GameSection == "half") {
                          teamas += '<span class="inout">46.</span>';
                        }
                      }               
                    }            
                  }
                }
              }
                          
              var ShortName = guestteam_lineup_players[pl].ShortName;
              var Players_name = ShortName.split(" ");                               
              if(Players_name.length == 1 ){
                var Players_final = Players_name[0];
              } else {
                var Players_final = Players_name[1];
              } 
        
              guestteam_players_html += '<li style="order:' + order + '">' + guestteam_lineup_players[pl].ShirtNumber + '  ' + Players_final + ' ' + leader + ' <span class="inout_wrap">' + teamas + '</span> </li>';
          }
    
          $('.aufstellung-main.aufstellung  ul.aufstellung-list-2').html(guestteam_players_html);
          $('.aufstellung-main.ersatzbank-guest  ul.aufstellung-list-2').html(guestteam_players_html);
    
          for (var pl = 0; pl < guestteam_bench_players.length; pl++) {
                      
            var order = guestteam_bench_players[pl].ShirtNumber;
            var ShortName = guestteam_bench_players[pl].ShortName;
            var Players_name = ShortName.split(" ");
            
            if(Players_name.length == 1 ){
              var Players_final = Players_name[0];
            } else {
              var Players_final = Players_name[1];
            }
    
            var teamas ='';
            if(Substitution.length > 0){
              for(var s1=0;s1<Substitution.length;s1++){ 
                for(var s=0;s<Substitution[s1].length;s++){
                  var Sub_attributes = Substitution[s1][s]['@attributes'];
                  if(Sub_attributes.PlayerInAlias == guestteam_bench_players[pl].ShortName){
                    if(Sub_attributes.TeamRole == 'guest'){
                      var MinuteOfPlay_In = Sub_attributes.MinuteOfPlay;
                      if (typeof MinuteOfPlay_In !== 'undefined'){
                        teamas += '<span class="inout">'+MinuteOfPlay_In+'</span>';
                      }
                      else if(Sub_attributes.GameSection == "half") {
                        teamas += '<span class="inout">46.</span>';
                      }
                    }
                  }
                  if(Sub_attributes.PlayerOutAlias == guestteam_bench_players[pl].ShortName){
                    if(Sub_attributes.TeamRole == 'guest'){
                      var MinuteOfPlay_Out = Sub_attributes.MinuteOfPlay;
                      if (typeof MinuteOfPlay_Out !== 'undefined'){
                        teamas += '<span class="inout">'+MinuteOfPlay_Out+'</span>';
                      }
                      else if(Sub_attributes.GameSection == "half") {
                        teamas += '<span class="inout">46.</span>';
                      }
                    }               
                  }            
                }
              }
            }
                        
            guestteam_betch_players_html += '<li style="order:' + order + '">' + guestteam_bench_players[pl].ShirtNumber + '  ' + Players_final + ' <span class="inout_wrap">' + teamas + '</span></li>';
          }
    
          $('.aufstellung-main.ersatzbank-guest ul.ersatzbank-list-2').html(guestteam_betch_players_html);
    
        }
              
          
        // spielplan - data  
        var html = '';
        var d2 = new Date();
        var matchDay = details.MatchesPerMatchDay;
        if(matchDay.length > 0){
          for (var mp = 0; mp < matchDay.length; mp++) {            
            if(matchDay[mp].CompetitionName == "SUI Super league"){
              if(matchDay[mp].CompetitionName == "SUI Super league"){
                var CompetitionName = "SUI Super League";
              }else {
                var CompetitionName = matchDay[mp].CompetitionName;
              }
    
              var image_default_path = 'https://aicofcz.s3.eu-central-1.amazonaws.com/';       
    
              var today_withzone = changeTimeZone(new Date(), 'Europe/Zurich');                
              var PlannedKickoffTime_withzone = changeTimeZone(new Date(matchDay[mp].PlannedKickoffTime), 'Europe/Zurich'); 
              //console.log(today_withzone,PlannedKickoffTime_withzone,matchDay[mp].PlannedKickoffTime);
                
              var PlannedKickoffTime = new Date(matchDay[mp].PlannedKickoffTime);                 
              var hours = Math.abs(d2 - PlannedKickoffTime) / 36e5;                  
              
              if(today_withzone <= PlannedKickoffTime_withzone){                 
                var score = 'VS';
              } else {                  
                if(matchDay[mp].Score == "" || matchDay[mp].Score == null){
                 var score = 'VS';
                }else {
                  var score = matchDay[mp].Score;
                }
              }
                
              html += '<div class="match-block" data-order="'+ hours +'">';
              html += '<div class="match-main-inner">';
             
              html += '<div class="match-date-wrapper">';
              html += '<div class="date">' + formatDateStringforsflmatch(matchDay[mp].PlannedKickoffTime) + '</div>';
              
              if(matchDay[mp].StadiumName != "" && matchDay[mp].StadiumName != null){  
                html += '<div class="match-type">';
                html += matchDay[mp].StadiumName;               
                html += '</div>';
              }
              html += '</div>';
              html += '<div class="match-wrapper-inner">';
              html += '<div class="team-1 home_team">';
              
              if(matchDay[mp].HomeTeamLogo != "" && matchDay[mp].HomeTeamLogo != null){
                //var imagesrc = image_default_path+matchDay[mp].HomeTeamLogo;
                var imagesrc = matchDay[mp].HomeTeamLogo;
                html += '<div class="team-img">';
                html += '<img class="lazy" srcset="'+imagesrc+'" alt="" loading="lazy">';
                html += '</div>';
              }
              html += '<h2 class="team-name">' + matchDay[mp].HomeTeamName + '</h2>';
              html += '</div>';
              html += '<div class="team-score-wrapper">';                
               
              html += '<div class="team-score">' + score + '</div>';                
              html += '</div>';
              html += '<div class="team-2">';
              
              if(matchDay[mp].GuestTeamLogo != "" && matchDay[mp].GuestTeamLogo != null){
                //var imagesrc = image_default_path+matchDay[mp].GuestTeamLogo;
                var imagesrc = matchDay[mp].GuestTeamLogo;
                html += '<div class="team-img">';
                html += '<img class="lazy" srcset="'+imagesrc+'" alt="" loading="lazy">';
                html += '</div>';
              }
              html += '<h2 class="team-name">' + matchDay[mp].GuestTeamName + '</h2>';
              html += '</div>';
              html += '</div>';
              
              html += '</div>';              
              html += '</div>';
                
            }
          }
    
          $('.tab-pane-content-spieltag .next-match-inner').html(html);
    
          $(".tab-pane-content-spieltag .next-match-inner").html($('.tab-pane-content-spieltag .next-match-inner .match-block').sort(function(x, y) {
             var value_x = $(x).data('order');
             var arr_x = [];
             arr_x = value_x
                  
             var value_y = $(y).data('order');
             var arr_y = [];
             arr_y = value_y
          
             var arel = parseInt( arr_x);
             var brel = parseInt(arr_y);             
          
            return arel > brel ? -1 : 1;
          })); 
                  
          var btn_html = '';
          btn_html += '<div class="center">';            
          btn_html += '<a class="button button--primary" href="/pages/spielplan">'+spielbutton[lang]+'</a>';
          btn_html += '</div>';
          $(btn_html).insertAfter('.tab-pane-content-spieltag .next-match-inner'); 
                  
        }
        else {
          $('.match-center-tabs li.spieltag').hide();
        }
    
        if (gender == 'WOMEN' && soccerLeague == "Meisterschaft AWSL") { 
           $('.match-center-tabs li.tabelle').show();
           $('.tab-content .tab-pane-content-tabelle-men').hide();
           $('.tab-content .tab-pane-content-tabelle-frauen').removeClass('hidden');
        }
        /*else 
        {
          
          var match_table_url = "https://app.aico.swiss/19838/api/v1/aico-matches/" + last_part + "/table";
          var settings = {
              "url": match_table_url,
              "method": "GET",
              "timeout": 0,
              "headers": {
                  "Authorization": authorization,
                  "Content-Type": "application/json"
              }
          };
    
          $.ajax(settings).done(function(response) {
    
            if (response.data == null) {
              $('.match-center-tabs .tabelle').hide();
            } else{
              var table = response.data.table;
              var matches = table.entries;
              var table_html = '';
              var form = '';
              var form_text = '';
              var form_class = '';
    
              for (var m = 0; m < matches.length; m++) {
                var active_class = '';
                form = matches[m].wins - matches[m].losses;
                if (form > 0) {
                  form_text = 'S';
                  form_class = 'up';
                } else if (form == 0) {
                  if (matches[m].draws == 0) {
                    form_text = '-';
                    form_class = '';
                  }
                  if (matches[m].draws > 0) {
                    form_text = 'U';
                    form_class = '';
                  }
                } else {
                  form_text = 'N';
                  form_class = 'down';
                }
                if (matches[m].club == 'FC Zürich') {
                    active_class = 'fc-zurich-highlight-row';
                }
    
                if(matches[m].tendency != null && matches[m].tendency != ''){
                  form_class = matches[m].tendency;
                }
                if(matches[m].logo != null){
                  var logo = '<span class="team-img"><img src="'+matches[m].logo+'" alt="'+matches[m].club+'" loading="lazy" width="26" height="26"></span>';
                }else{
                  var logo = '';
                }
    
                table_html += '<div class="tabelle-row ' + active_class + '">';
                table_html += '<div class="th-1">' + matches[m].position + '</div>';
                table_html += '<div class="th-2"><span class="' + form_class + '"></span>'+logo + matches[m].club + '</div>';
                table_html += '<div class="th-3">' + matches[m].gamesPlayed + '</div>';
                table_html += '<div class="th-4">' + matches[m].wins + '</div>';
                table_html += '<div class="th-5">' + matches[m].draws + '</div>';
                table_html += '<div class="th-6">' + matches[m].losses + '</div>';
                table_html += '<div class="th-7">' + matches[m].goalsScored + '</div>';
                table_html += '<div class="th-8">' + matches[m].goalsAgainst + '</div>';
                table_html += '<div class="th-9">' + matches[m].goalsDifference + '</div>';
                table_html += '<div class="th-10">' + form_text + '</div>';
                table_html += '<div class="th-11">' + matches[m].points + '</div>';
                table_html += '</div>';
              }
              $('.tab-pane-content-tabelle .tabelle-content').html(table_html);
            }
    
          }); // Table Response Close
        } // SFL Women Table else Close*/
        
      } // if(details != null)
      else{
        $('.match-center-tabs .statistik').hide();
        $('.match-center-tabs .aufstellung').hide();
        $('.match-center-tabs .spieltag').hide();
      }
    } // SFL Else Close
  
  } // Future SFL Else Close

}); // Main Response Close

slickCarousel();

/* Encode string to slug */
function convertToSlug( str ) {
    
  //replace all special characters | symbols with a space
  str = str.replace(/[`~!@#$%^&*()_\-+=\[\]{};:'"\\|\/,.<>?\s]/g, ' ')
           .toLowerCase();
    
  // trim spaces at start and end of string
  str = str.replace(/^\s+|\s+$/gm,'');
    
  // replace space with dash/hyphen
  str = str.replace(/\s+/g, '-');                  
  return str;
}

function slickCarousel() {
  $('.slider-for').not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      asNavFor: '.slider-nav',
      adaptiveHeight: true,
      //       dots: true,
  });
  $('.slider-nav').not('.slick-initialized').slick({
      slidesToShow: slidetoshow,
      slidesToScroll: 1,
      infinite: false,
      asNavFor: '.slider-for',
      //       dots: true,
      centerMode: true,
      focusOnSelect: true,
      responsive: [{
          breakpoint: 767,
          settings: {
              slidesToShow: 6,
          }
      }]
  });
}

function destroyCarousel() {
  if ($('.slider-for').hasClass('slick-initialized')) {
      $('.slider-for').slick('destroy');
  }
  if ($('.slider-nav').hasClass('slick-initialized')) {
      $('.slider-nav').slick('destroy');
  }
}